/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(3);

/***/ },
/* 1 */
/***/ function(module, exports) {

	/*
	 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
	 *
	 * Uses the built in easing capabilities added In jQuery 1.1
	 * to offer multiple easing options
	 *
	 * TERMS OF USE - jQuery Easing
	 * 
	 * Open source under the BSD License. 
	 * 
	 * Copyright © 2008 George McGinley Smith
	 * All rights reserved.
	 * 
	 * Redistribution and use in source and binary forms, with or without modification, 
	 * are permitted provided that the following conditions are met:
	 * 
	 * Redistributions of source code must retain the above copyright notice, this list of 
	 * conditions and the following disclaimer.
	 * Redistributions in binary form must reproduce the above copyright notice, this list 
	 * of conditions and the following disclaimer in the documentation and/or other materials 
	 * provided with the distribution.
	 * 
	 * Neither the name of the author nor the names of contributors may be used to endorse 
	 * or promote products derived from this software without specific prior written permission.
	 * 
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
	 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
	 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
	 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
	 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
	 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
	 * OF THE POSSIBILITY OF SUCH DAMAGE. 
	 *
	*/
	
	// t: current time, b: begInnIng value, c: change In value, d: duration
	jQuery.easing['jswing'] = jQuery.easing['swing'];
	
	jQuery.extend( jQuery.easing,
	{
		def: 'easeOutQuad',
		swing: function (x, t, b, c, d) {
			//alert(jQuery.easing.default);
			return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
		},
		easeInQuad: function (x, t, b, c, d) {
			return c*(t/=d)*t + b;
		},
		easeOutQuad: function (x, t, b, c, d) {
			return -c *(t/=d)*(t-2) + b;
		},
		easeInOutQuad: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t + b;
			return -c/2 * ((--t)*(t-2) - 1) + b;
		},
		easeInCubic: function (x, t, b, c, d) {
			return c*(t/=d)*t*t + b;
		},
		easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
		easeInOutCubic: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t + b;
			return c/2*((t-=2)*t*t + 2) + b;
		},
		easeInQuart: function (x, t, b, c, d) {
			return c*(t/=d)*t*t*t + b;
		},
		easeOutQuart: function (x, t, b, c, d) {
			return -c * ((t=t/d-1)*t*t*t - 1) + b;
		},
		easeInOutQuart: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
			return -c/2 * ((t-=2)*t*t*t - 2) + b;
		},
		easeInQuint: function (x, t, b, c, d) {
			return c*(t/=d)*t*t*t*t + b;
		},
		easeOutQuint: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t*t*t + 1) + b;
		},
		easeInOutQuint: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
			return c/2*((t-=2)*t*t*t*t + 2) + b;
		},
		easeInSine: function (x, t, b, c, d) {
			return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
		},
		easeOutSine: function (x, t, b, c, d) {
			return c * Math.sin(t/d * (Math.PI/2)) + b;
		},
		easeInOutSine: function (x, t, b, c, d) {
			return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
		},
		easeInExpo: function (x, t, b, c, d) {
			return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
		},
		easeOutExpo: function (x, t, b, c, d) {
			return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
		},
		easeInOutExpo: function (x, t, b, c, d) {
			if (t==0) return b;
			if (t==d) return b+c;
			if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
			return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
		},
		easeInCirc: function (x, t, b, c, d) {
			return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
		},
		easeOutCirc: function (x, t, b, c, d) {
			return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
		},
		easeInOutCirc: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
			return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
		},
		easeInElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		},
		easeOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
		},
		easeInOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
			return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
		},
		easeInBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			return c*(t/=d)*t*((s+1)*t - s) + b;
		},
		easeOutBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
		},
		easeInOutBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158; 
			if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
			return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
		},
		easeInBounce: function (x, t, b, c, d) {
			return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
		},
		easeOutBounce: function (x, t, b, c, d) {
			if ((t/=d) < (1/2.75)) {
				return c*(7.5625*t*t) + b;
			} else if (t < (2/2.75)) {
				return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
			} else if (t < (2.5/2.75)) {
				return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
			} else {
				return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
			}
		},
		easeInOutBounce: function (x, t, b, c, d) {
			if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
			return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
		}
	});
	
	/*
	 *
	 * TERMS OF USE - EASING EQUATIONS
	 * 
	 * Open source under the BSD License. 
	 * 
	 * Copyright © 2001 Robert Penner
	 * All rights reserved.
	 * 
	 * Redistribution and use in source and binary forms, with or without modification, 
	 * are permitted provided that the following conditions are met:
	 * 
	 * Redistributions of source code must retain the above copyright notice, this list of 
	 * conditions and the following disclaimer.
	 * Redistributions in binary form must reproduce the above copyright notice, this list 
	 * of conditions and the following disclaimer in the documentation and/or other materials 
	 * provided with the distribution.
	 * 
	 * Neither the name of the author nor the names of contributors may be used to endorse 
	 * or promote products derived from this software without specific prior written permission.
	 * 
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
	 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
	 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
	 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
	 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
	 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
	 * OF THE POSSIBILITY OF SUCH DAMAGE. 
	 *
	 */

/***/ },
/* 2 */
/***/ function(module, exports) {

	/*
	 * 	exResize 0.1.0 - jQuery plugin
	 *	written by Cyokodog
	 *
	 *	Copyright (c) 2010 Cyokodog (http://d.hatena.ne.jp/cyokodog/)
	 *	Dual licensed under the MIT (MIT-LICENSE.txt)
	 *	and GPL (GPL-LICENSE.txt) licenses.
	 *
	 *	Built for jQuery library
	 *	http://jquery.com
	 *
	 */
	(function($){
		var API = function(api){
			var api = $(api),api0 = api[0];
			for(var name in api0)
				(function(name){
					if($.isFunction( api0[name] ))
						api[ name ] = (/^get[^a-z]/.test(name)) ?
							function(){
								return api0[name].apply(api0,arguments);
							} :
							function(){
								var arg = arguments;
								api.each(function(idx){
									var apix = api[idx];
									apix[name].apply(apix,arg);
								})
								return api;
							}
				})(name);
			return api;
		}
	
		$.ex = $.ex || {};
		$.ex.resize = function(idx , targets , option){
			if ($.isFunction(option)) {
				option = {callback : option};
			}
			var o = this,
			c = o.config = $.extend({} , $.ex.resize.defaults , option);
			c.targets = targets;
			c.target = c.watchTarget = c.targets.eq(idx);
			c.index = idx;
			// c.oldBrowser = $.browser.msie && ($.browser.version < 8.0 || !$.boxModel);
			c.oldBrowser = !$.support.opacity&&!$.support.tbody;//IE6-7
			c.key = { height : '', width : ''};
			if (c.contentsWatch) {
				o._createContentsWrapper();
			}
			c.currentSize = c.newSize = o.getSize();
			if (c.resizeWatch) o._resizeWatch();
		}
		$.extend($.ex.resize.prototype, {
			_createContentsWrapper : function(){
				var o = this, c = o.config;
				var style = c.oldBrowser ? 'zoom:1;display:inline' : 'display:inline-block';
				c.watchTarget = c.target.wrapInner('<div style="' + style + ';width:' + c.target.css('width') + '"/>').children();
				return o;
			},
			_resizeWatch : function(){
				var o = this, c = o.config;
				setTimeout(function(){
					if (c.contentsWatch) {
						if (c.watchTarget.prev().size() > 0 || c.watchTarget.next().size() > 0 || c.watchTarget.parent().get(0) != c.target.get(0)) {
							c.watchTarget.replaceWith(c.watchTarget.get(0).childNodes);
							o._createContentsWrapper();
						}
					}
					if (o._isResize()) {
						c.currentSize = c.newSize;
						c.callback.call(c.watchTarget.get(0),o);
					}
					o._resizeWatch();
				},c.resizeWatch);
			},
			_isResize : function () {
				var o = this, c = o.config;
				var ret = false;
				c.newSize = o.getSize();
				for (var i in c.key) {
					ret = ret || (c.newSize[i] != c.currentSize[i]);
				}
				return ret;
			},
			getTargets : function(){
				return this.config.targets;
			},
			getTarget : function(){
				return this.config.target;
			},
			getSize : function () {
				var o = this, c = o.config;
				if (c.contentsWatch) c.watchTarget.css('width','auto');
				var ret = {};
				for (var i in c.key) {
					ret[i] = c.watchTarget[i]();
				}
				if (c.contentsWatch) c.watchTarget.css('width',c.target.css('width'));
				return ret;
			}
		});
		$.ex.resize.defaults = {
			contentsWatch : false,
			resizeWatch : 100,
			callback : function(){}
		}
		$.fn.exResize = function(option){
			var targets = this,api = [];
			targets.each(function(idx) {
				var target = targets.eq(idx);
				var obj = target.data('ex-resize') || new $.ex.resize( idx , targets , option);
				api.push(obj);
				target.data('ex-resize',obj);
			});
			return option && option.api ? API(api) : targets;
		}
	})(jQuery);


/***/ },
/* 3 */
/***/ function(module, exports) {

	
	/*
	 * flickSlide　jQueryプラグイン
	 *
	 * author: aquy.k ( hiroshi kawada )
	 * create date: 2013-06-10
	 * ver 0.7.0
	 *
	 *
	 *
	 * 更新履歴
	 *
	 * 2013.04.12　0.5.0　ある程度の機能を備えた安定版
	 * 2013.06.10　0.6.0　ページャースライド機能に加え、各種（考えられる全ケースの対策）調整と、機能拡張、強化版
	 * 2015.04.20　0.7.0　pagerContainer.length が未設定の場合のエラー解消
	 *
	 * 必要jsライブラリ＆設置コード例（最小）
	<head>
	…
	<link rel="stylesheet" href="../../lib/css/jquery.flickslide.css">
	<script src="http://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js"></script>
	<script src="../../lib/js/jquery.exresize.0.1.0.js"></script>
	<script src="../../lib/js/jquery.timers.js"></script>
	<script src="../../lib/js/jquery.easing.1.3.js"></script>
	<script src="../../lib/js/jquery.flickslide.0.6.0.js"></script>
	<script>
	
		$(function(){
	
			$("#flick-slide").flickSlide();
		});
	</script>
	…
	</head>
	
	<body>
	…
	<section id="flick-slide">
	
	<div>
	<ol>
	    <li><img src="../../lib/images/1.jpg" alt=""></li>
	    <li><img src="../../lib/images/2.jpg" alt=""></li>
	    <li><img src="../../lib/images/3.jpg" alt=""></li>
	</ol>
	</div>
	
	</section>
	…
	</body>
	 *
	 *
	 *
	 * 高速化メモ
	 *
	 * ifとfunction{if}ではfunctionを通る段階で４倍時間がかかりif処理に時間がかかる
	 * jQuery自体重いので軽量化するには極力jQuery関数やfunctionは使わない方がよい
	 * 例：jQueryのIDセレクタ$('#id')よりネイティブgetElementByIdId('id')の方が爆速　等
	 * $(".name")クラスだけを指定するのは禁止 $("div.name")の方がループ回数が大幅に削減される
	 *
	 * javascriptネイティブとjQueryでCSSの要素チェックのベンチーマークAdd Star
	 * http://d.hatena.ne.jp/maruloop/20120109/1326091716
	 *
	 * Chromeにて変数+ネイティブだとフルjQueryに比べて20倍早い
	 * 変数+ネイティブ（108）< ダイレクト+ネイティブ（180）< 変数+jQueryAPI（1484）< jQueryセレクタAPIダイレクト+jQueryAPI（2188）
	 *
	 * HTML5 × CSS3 × jQueryを真面目に勉強 ? #7 jQueryのセレクタAPIについて詳しく
	 * http://dev.classmethod.jp/etc/html5-x-css3-x-jquery-7-jquery-selector/
	 *
	 *
	 *
	 * ※Android不具合情報
	 *
	 * ※Android 4.0は、touchstart, touchmove で、event.preventDefault() を実行しないと、touchendは実行されない
	 * http://www.gravitypianist.info/android-40touchend
	 *
	 * Androidの標準ブラウザにおけるリンク要素のアウトラインの不具合について
	 * http://blog.bluearrowslab.com/smartphone/topicks/534/
	 *
	 * ※au URBANOがCSSのopacityを動的にアルファ変更すると激重で0.5秒固まる
	 * ※Androidは基本的に動的処理に弱い
	 *
	 *
	 *
	 * ※バグ情報
	 * IE8のみopacityで親要素を透明にしても子要素は透明にならないので直接指定するしかない
	 *
	 *
	 *
	 * ※その他注意事項
	 * IE7のみコンフィグ設定時のプロパティーで最後の列に,区切り（例～～ opacity : true, ;）を入れると処理が停止するので注意
	 *
	 */
	
	//※※Line427 本番前に変更する必要あり。
	
	(function($){
	
		// プラグイン名（flickSlide）を指定　関数にコンフィグオブジェクトを渡す
		$.fn.flickSlide = function( config ){
	
			// 要素を退避
			var elements = this;
	
			/*
			 * 引数の初期値を設定（カンマ区切り）
			 -----------------------------------------------------*/
			 var defaults = {
	
				// エレメント参照：メイン
				mainElement : elements.children("div").first(),			// 親要素内直下の最初のdiv要素を選択
	
				// エレメント参照：メインネイバーズボタン
				mainNeighborsElement : elements.children("ul").first(),	// 親要素内直下の最初のul要素を選択
	
				// エレメント参照：ページャー
				pagerElement : null,
	
				// エレメント参照：ページャーネイバーズボタン
				pagerNeighborsElement : null,
	
				// メインネイバーズボタンの自動生成
				createMainNeighbors : false,
	
				// メインネイバーズボタンの垂直位置を中央に
				mainNeighborsVerticalCenter : true,
	
				// ページャーの自動生成　null = なし　"pointer" = CSSポインター　"thumbnail" = メインエレメントのサムネイルを自動コピー
				createPager : null,
	
				// ページャーのスライド機能
				pagerSlide : false,
	
				// ページャーネイバーズボタンの自動生成
				createPagerNeighbors : false,
	
				// ページャーネイバーズボタンの垂直位置を中央に
				pagerNeighborsVerticalCenter : true,
	
				// メインエレメントの子liの横幅設定　数値1以上 = px　デフォルト = 0:100%（※outerも含む）
				mainListWidth : 0,
	
				// ページャーエレメントの子liの横幅設定　数値1以上 = px　デフォルト = 0:auto（※outerも含む）
				pagerListWidth : 0,
	
				// フリック操作性設定
				//-----------------------------------------------------
				// タッチムーブ時の移動量補正　デフォルト = 0.5:半減（アップルストア仕様）　1:ダイレクト　2:2倍
				movementCorrection : 0.5,
	
				// タッチムーブ時に垂直に一定以上動かした場合の感知範囲　px
				verticalSensingRange : 0,
	
				// touchend時でスライド送りをするかの左右のゆとり（liの幅で計算）　デフォルト = 0.1:左右5% 単位（軽い）　0:遊びなし（固い）　1:左右50%（重い）
				spaceRange : 0.1,
				//-----------------------------------------------------
	
				// 繰り返し
				repeat : false,
	
				// 自動スライド間隔の秒数　0:停止
				timer : 0,
	
				// hover時にタイマーを停止する
				hoverStopTimer : true,
	
				// スライドが完了するまでのスピード　デフォルト400:アップルストアぐらい
				slideSpeed : 400,
	
				/* CSS3 transitionを使用した加速/減速
				 * "ease"			= 開始と終了を滑らかに（初期値） = cubic-bezier(0.25, 0.1, 0.25, 1.0)
				 * "linear"			= 一定 = cubic-bezier(0.0, 0.0, 1.0, 1.0)
				 * "ease-in"		= ゆっくり開始 = cubic-bezier(0.42, 0, 1.0, 1.0)
				 * "ease-out"		= ゆっくり終了 = cubic-bezier(0, 0, 0.58, 1.0)
				 * "ease-in-out"	= ゆっくり開始、ゆっくり終了 = cubic-bezier(0.42, 0, 0.58, 1.0)
				 * "カスタム設定"	= 3次ベジェ曲線のP1とP2を (x1, y1, x2, y2) で指定
				 */
				 transitionEasing : "ease",
	
				// jquery.easing.1.3.jsを使用した加速/減速 動作参考：http://semooh.jp/jquery/cont/doc/easing/
				jqueryEasing : "easeOutExpo",
	
				// ネイバーズボタンの非アクティブ時に埋め込まれるクラス名
				disabledClassName : "disabled",
	
				// ページャーアクティブ時に埋め込まれるクラス名
				selectedClassName : "active",
	
				// ページャーの透明度処理によるロールオーバー表現設定　0 ～ 1まで　デフォルト = 0.5:半透明　1:オフ （※Androidはアルファ処理が激重（約0.5秒フリーズ）iOSも若干重い（約0.1秒）ので、SPは強制的に1）
				opacity : 0.5,
	
				// 透明度の変化が終わるまでのスピード
				opacityAnimateSpeed : 300,
	
				// デバッグを行うかどうか　// ※IE8以下はobjectプロパティがundefinedの場合中断されるので注意　IE8以下ではデバッグしない方が良い
				debug : false,
	
				modal : false // ※モーダル表示拡張
			};
	
			// 渡されたコンフィグとデフォルトをマージする
			var settings = $.extend( {}, defaults, config );
	
	
	
			//-----------------------------------------------------
	
	
	
			// 最小設置時の自動生成の場合のデフォルトクラス名
			var defaultClassNameMain			= "jquery_flick-slide_main";
			var defaultClassNameMainNeighbors	= "jquery_flick-slide_main-neighbors";
	
			var defaultClassNamePagerPointer	= "jquery_flick-slide_pointer";
			var defaultClassNamePager			= "jquery_flick-slide_pager";
			var defaultClassNamePagerSlide		= "jquery_flick-slide_pager-slidemode";
			var defaultClassNamePagerNeighbors	= "jquery_flick-slide_pager-neighbors";
	
			var defaultClassNameNeighborsPrev	= "prev";
			var defaultClassNameNeighborsNext	= "next";
	
	
	
			/*
			 * 基礎格納
			 -----------------------------------------------------*/
			 var mainElement				= $( settings.mainElement );
			 var mainNeighborsElement	= $( settings.mainNeighborsElement );
			 var pagerElement			= $( settings.pagerElement );
			 var pagerNeighborsElement	= $( settings.pagerNeighborsElement );
	
			var mainContainer			= mainElement.children('ol');	// フローコンテンツ的にolが相応しいのでとりあえず強制
			var mainListContainer		= mainContainer.children('li');
			var listCount				= mainListContainer.length;	// リスト数
	
			// メインエレメントにid、classの属性がなければデフォルトクラス名を当てる
			if ( typeof mainElement.attr('id') === "undefined" && typeof mainElement.attr('class') === "undefined" ) {
	
				mainElement.addClass( defaultClassNameMain );
			}
	
	
			// 外部横幅css対策　cssでデザイン的に設定される場合があるので取得処理　outerWidth({ margin: true });でも可だがこっちで軽量化
			// main li　※全て均等に掛っている事が条件　個別で違う場合は崩壊する
			var mainListFirst		= mainListContainer.first();
			var mainMarginWidth		= parseInt( mainListFirst.css('margin-left') ) + parseInt( mainListFirst.css('margin-right') );				// margin幅計算
			var mainPaddingWidth	= parseInt( mainListFirst.css('padding-left') ) + parseInt( mainListFirst.css('padding-right') );				// padding幅計算
			var mainBorderWidth		= parseInt( mainListFirst.css('border-left-width') ) + parseInt( mainListFirst.css('border-right-width') );	// border幅計算
			var mainOuterWidth		= mainMarginWidth + mainPaddingWidth + mainBorderWidth;	// 外部横幅
	
	
			// タッチ操作可能かどうか
			var touchable = typeof ontouchstart !== 'undefined';
	
	
	
			/*
			 * CSS3 アニメーション　で使用するベンダープレフィックスを摘出
			 -----------------------------------------------------*/
			var vendorPrefix = [	// ※注意　transitionを先頭に置くと何故か非対応のChromeが拾って動かなくなるので一番下に
	
			[ '-webkit-transition', '-webkit-transition', '-webkit-transform', 'webkitTransitionEnd' ],
			[ 'MozTransition',      '-moz-transition',    '-moz-transform',    'transitionend' ],
			[ 'OTransition',        '-o-transition',      '-o-transform',      'oTransitionEnd' ],
			[ '-ms-transition',     '-ms-transition',     '-ms-transform',     'msTransitionEnd' ],
			[ 'transition',         'transition',         'transform',         'transitionEnd' ]
			];
	
			var div = document.createElement('div');	// undefinedかどうか調べる
			var css3Animation = {};
	
			for ( var i = 0, len = vendorPrefix.length; i < len; i++ ) {
	
				if ( div.style[ vendorPrefix[i][0] ] !== void 0 ) {	// undefinedではなく該当するプロパティーがあれば
	
					css3Animation.transition    = vendorPrefix[i][1];
					css3Animation.transform     = vendorPrefix[i][2];
					css3Animation.transitionend = vendorPrefix[i][3];
	
					break;
				}
			}
	
			// フラグ用
			var css3AnimationSupport = css3Animation.transition && css3Animation.transform;
	
	
	
			/*
			 * 動的変数をローカル宣言
			 -----------------------------------------------------*/
			var main = {			// メインエレメント用変数オブジェクト
	
				name : "main",		// 識別時に使用する名前
				element : mainContainer,
				listWidth : 0,		// メインエレメント内子liの横幅
				leftIndent : 0,		// メインエレメントの子liの横幅が指定された場合のセンタリング用インデント値
				moveSpeed : 0,		// touchmoveの移動速度の監視に必要
				connectCount : 0,
				transform : false	// アニメーションの多重処理防止用フラグ　リサイズ時に無駄なcss.transitionを抑制
			};
	
			var mainRightEndLimit;	// スライド時の右端のリミット
			var mainClearSpace;		// フリック時の左右のゆとり
	
			var defaultHeight = $('body').height();	// 動的に高さが変更されるか監視する為の値　変化前を記憶しておく
	
			var yFlag = false;	// スクロール感知
			var xFlag = false;	// スライド感知
	
			var runningTimer = false;	// タイマーの多重処理防止用フラグ
			var time = 0;
	
	
	
			/*
			 * ユーザーエージェント
			 -----------------------------------------------------*/
			var strUserAgent = navigator.userAgent.toLowerCase();	// 文字列を小文字で出力
			var smartPhoneUserAgent	= [ 'iphone', 'ipad', 'ipod', 'android' ];
	
			var terminal = "pc";	// PC版は画像ドラッグでthis.touchedがtrueのままになるのでフォーカスを奪われないようにするためのフラグ
	
			for ( var i = 0; i < smartPhoneUserAgent.length; i++ ) {
	
				// スマートフォンの場合
				if ( strUserAgent.indexOf( smartPhoneUserAgent[i], 0 ) != -1 ) {
	
					terminal = "sp";
					settings.opacity = 1;	// スマートフォンの場合はレンダリング速度が低下するので強制的に透明処理を行わない（※特にAndroid）
	
					break;
				}
				/*
				// Androidの場合
				if ( strUserAgent.indexOf( 'android', 0 ) != -1 ) {
	
					settings.opacity = 1;	// ※Androidはアルファ処理が激重なので強制的に透明にしない
				}
				*/
			}
	
	
	
	
	
			/*
			 * 各種エレメント処理　自動生成関連
			 -----------------------------------------------------*/
	
	
	
			/*
			 * メインエレメント用　ネイバーズボタン（自動生成）
			 -----------------------------------------------------*/
			// 自動生成フラグ　＆　エレメントがない場合に要素を自動生成（多重設置回避）
			if ( settings.createMainNeighbors && !mainNeighborsElement.length ) {
	
				mainElement.before(	// .before IE7非対応
					'<ul class="'+ defaultClassNameMainNeighbors +'">'+
					'<li class="'+ defaultClassNameNeighborsPrev +'"></li>'+
					'<li class="'+ defaultClassNameNeighborsNext +'"></li>'+
					'</ul>'
					);
	
				mainNeighborsElement = elements.children( "ul."+ defaultClassNameMainNeighbors );
			}
	
			// prev、nextボタンが存在する場合
			if ( mainNeighborsElement.length ) {
	
				var setMainNeighbors = true;	// 処理を許可
	
				var mainPrevElement = mainNeighborsElement.children('li.'+ defaultClassNameNeighborsPrev );
				var mainNextElement = mainNeighborsElement.children('li.'+ defaultClassNameNeighborsNext );
			}
	
			if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
	
	
	
			/*
			 * ページャー
			 -----------------------------------------------------*/
			 var pagerContainer = pagerElement.children('ol');
	
			// "pointer"自動生成フラグ
			if ( settings.createPager == "pointer" && !pagerContainer.length ) {
	
				if ( !pagerElement.length ) {	// ページャーエレメントそのものがない場合
	
					elements.append('<div class="'+ defaultClassNamePagerPointer +'"><ol></ol></div>');
					pagerElement = elements.children( "div."+ defaultClassNamePagerPointer );
	
				} else {						// ページャーエレメントはあるもののol要素がない場合
	
					pagerElement.append('<ol></ol>');
				}
	
				pagerContainer = pagerElement.children('ol');
	
				for ( var i = 0; i < listCount; i++ ) {
	
					var addListTag = $('<li><span></span></li>');
					pagerContainer.append( addListTag );
				}
	
			// "thumbnail"自動生成フラグ
		} else if ( settings.createPager == "thumbnail" && !pagerContainer.length ) {
	
				if ( !pagerElement.length ) {	// ページャーエレメントそのものがない場合
	
					elements.append('<div class="'+ defaultClassNamePager +'"><ol></ol></div>');
					pagerElement = elements.children( "div."+ defaultClassNamePager );
	
				} else {						// ページャーエレメントはあるもののol要素がない場合
	
					pagerElement.append('<ol></ol>');
				}
	
				pagerContainer = pagerElement.children('ol');
	
				for ( var i = 0; i < listCount; i++ ) {
	
					var image = mainListContainer.eq(i).find("img").first().attr('src');
	
					// var addListTag = $('<li><span><img src="../../lib/'+ image +'"></span></li>');
					var addListTag = $('<li><span><img src="'+ image +'"></span></li>');
					pagerContainer.append( addListTag );
				}
			}
	
			// ページャーが存在する場合
			if ( pagerContainer.length ) {
	
				var setPager = true;	// 処理を許可
	
				var pagerListContainer	= pagerContainer.children('li');
	
				// pager li　※全て均等に掛っている事が条件　個別で違う場合は崩壊する
				var pagerListFirst		= pagerListContainer.first();
				var pagerMarginWidth	= parseInt( pagerListFirst.css('margin-left') ) + parseInt( pagerListFirst.css('margin-right') );				// margin幅計算
				var pagerPaddingWidth	= parseInt( pagerListFirst.css('padding-left') ) + parseInt( pagerListFirst.css('padding-right') );			// padding幅計算
				var pagerBorderWidth	= parseInt( pagerListFirst.css('border-left-width') ) + parseInt( pagerListFirst.css('border-right-width') );	// border幅計算
				var pagerOuterWidth		= pagerMarginWidth + pagerPaddingWidth + pagerBorderWidth;	// 外部横幅
	
				if ( settings.pagerSlide ) pagerElement.addClass( defaultClassNamePagerSlide );
				pagerListContainer.first().addClass( settings.selectedClassName );
	
				// CSS　opacityロールオーバー表現　opacityが1より低い場合は処理する
				if( settings.opacity < 1 ){
	
					// ※バグ　IE8はopacityで親要素を透明にしても子要素は透明にならないので直接指定するしかない
					var pagerContainerOpacityTarget = pagerListContainer;
	
					if ( strUserAgent.indexOf( 'msie 8', 0 ) != -1 && pagerListContainer.find('img').length ) {	// IE8で尚且つ子要素にimgがある場合
	
						pagerContainerOpacityTarget = pagerListContainer.find('img');
					}
	
					pagerContainerOpacityTarget.css({ opacity : settings.opacity });
	
					pagerContainerOpacityTarget.hover(
	
						function(){	// over
	
							$(this).stop().animate( { opacity: 1 }, settings.opacityAnimateSpeed );
						},
						function(){	// out
	
							$(this).stop().animate( { opacity: settings.opacity }, settings.opacityAnimateSpeed );
						}
						);
				}
	
			// 存在しないにも関わらずスライドフラグが立っている場合はオフにする
		} else if ( settings.pagerSlide ) {
	
			settings.pagerSlide = false;
		}
	
			// ページャー関連の動的変数　スライドさせる場合のローカル宣言
			if ( settings.pagerSlide ) {
	
				var pager = {			// ページャーエレメント用変数オブジェクト
	
					name : "pager",		// 識別時に使用する名前
					element : pagerContainer,
					listWidth : 0,		// ページャーエレメント内子liの横幅
					leftIndent : 0,		// ページャーエレメントの子liの横幅が指定された場合のセンタリング用インデント値
					moveSpeed : 0,		// touchmoveの移動速度の監視に必要
					connectCount : 0,
					transform : false	// アニメーション感知　リサイズ時に無駄なcss.transitionを抑制
				};
	
				var pagerRightEndLimit;
				var pagerClearSpace;
			}
	
	
	
			/*
			 * ページャーエレメント用　ネイバーズボタン（自動生成）
			 -----------------------------------------------------*/
			// ページャーが存在　＆　自動生成フラグ　＆　スライド機能が有効　＆　エレメントがない場合に要素を自動生成（多重設置回避）
			if ( setPager && settings.createPagerNeighbors && settings.pagerSlide && !pagerNeighborsElement.length ) {
	
				pagerElement.before(	// .before IE7非対応
					'<ul class="'+ defaultClassNamePagerNeighbors +'">'+
					'<li class="'+ defaultClassNameNeighborsPrev +'"></li>'+
					'<li class="'+ defaultClassNameNeighborsNext +'"></li>'+
					'</ul>'
					);
	
				pagerNeighborsElement = elements.children( "ul."+ defaultClassNamePagerNeighbors );
			}
	
			// prev、nextボタンが存在する場合
			if ( pagerNeighborsElement.length ) {
	
				var setPagerNeighbors = true;	// 処理を許可
	
				var pagerPrevElement = pagerNeighborsElement.children('li.'+ defaultClassNameNeighborsPrev );
				var pagerNextElement = pagerNeighborsElement.children('li.'+ defaultClassNameNeighborsNext );
			}
	
			if( setPagerNeighbors && !settings.repeat ) neighborsSetDisabled();
	
	
	
			/*
			 * モーダル表示用クローン（自動生成）
			 -----------------------------------------------------*/
			 if ( settings.modal ) {
			 	var x = elements.attr("id");
			 	x = x +"2";
			 	console.log(x);
			 	//mainElement.clone(true).appendTo("#flick-slide");
			 	elements.clone(true).insertAfter(this).removeAttr("id").attr("id",x);
			 }
	
	
	
	
	
	
	
	
	
	
			//-----------------------------------------------------
	
	
	
	
	
			/*
			 * 表示サイズ自動処理
			 -----------------------------------------------------*/
			 $(window).load( function() {
	
			 	autoSizing();
	
			 	if( settings.debug ) debug( {}, "ロード完了" );
			 });
	
	
	
			 $(window).resize( function(e){
	
			 	autoSizing();
	
				defaultHeight = $('body').height();		// $(window).resizeからはexResizeが実行されないようにdefaultHeightを更新
	
				if( settings.debug ) debug( {}, "リサイズ" );
			});
	
	
	
			// 自身以外から動的に高さが変更されスクロールバーが出現した場合の横幅再計算
			/*
			 * メモ
			 *
			 * $(window).resize()では動的な縦幅の変更は監視できないので、jquery.exresize.0.1.0.jsでbody要素がリサイズされるか監視
			 * この処理は重く多用できないので動的変更時（複数設置した場合の初回用）のみで使用すること
			 */
			 $('body').exResize( function(){
	
				if( defaultHeight != $('body').height() ) {	// 記憶した縦幅と現在の縦幅が違う場合
	
					autoSizing();
	
					if( settings.debug ) debug( {}, "動的リサイズ" );
				}
			});
	
	
	
			// 自動サイズ処理
			function autoSizing() {
	
				var mainElementWidth = parseInt( mainElement.css('width') );
	
				// メインエレメントの子liの横幅
				if ( !settings.mainListWidth )	{	// 0の場合はmainElementの幅（100%）
	
					main.listWidth = mainElementWidth;
	
				} else {						// 設定があれば
	
					main.listWidth = settings.mainListWidth;
					//main.leftIndent = ( mainElementWidth - main.listWidth ) / 2;
	
	
					main.leftIndent = 0;
	
					//console.log(main.leftIndent);
	
					//main.leftIndent = ( mainElementWidth - main.listWidth );
				}
	
				mainRightEndLimit = -main.listWidth * ( listCount - 1 );
				mainClearSpace = ( main.listWidth * settings.spaceRange ); // フリック時の左右のゆとり
	
				mainContainer.css({ width : main.listWidth * listCount });
	
				// 横座標　式
				var abscissa = main.leftIndent + -main.listWidth * main.connectCount;
	
				if ( css3AnimationSupport ) {	// css3Animationが使用できる場合
	
					var css = {};
	
					// アニメーション中じゃなければ無駄なトランジションを消してアニメーションさせない
					if ( !main.transform ) css[ css3Animation.transition ] = 'none';
					css[ css3Animation.transform ] = 'translate3d( '+ abscissa +'px, 0, 0 )';
	
					mainContainer.css( css );
	
				} else {						// 古いブラウザ等、非対応の場合
	
					mainContainer.css({ left: abscissa });
				}
	
				mainListContainer.css({ width : main.listWidth - mainOuterWidth });
				mainElement.css({ height : mainContainer.height() }); // 縦幅の最大値
	
	
	
				// メインエレメントにネイバーズボタンが存在　＆　縦位置の中央フラグがtrueの場合は中央揃えに
				if ( setMainNeighbors && settings.mainNeighborsVerticalCenter ) {
	
					var mainPrevHeight = mainPrevElement.height() + parseInt( mainPrevElement.css('border-top-width') ) + parseInt( mainPrevElement.css('border-bottom-width') );
					var mainNextHeight = mainNextElement.height() + parseInt( mainNextElement.css('border-top-width') ) + parseInt( mainNextElement.css('border-bottom-width') );
					mainPrevElement.css({ 'margin-top' : mainElement.height() / 2 - mainPrevHeight / 2 });
					mainNextElement.css({ 'margin-top' : mainElement.height() / 2 - mainNextHeight / 2 });
				}
	
				// ページャーエレメントにネイバーズボタンが存在　＆　縦位置の中央フラグがtrueの場合は中央揃えに
				if ( setPagerNeighbors && settings.pagerNeighborsVerticalCenter ) {
	
					var pagerPrevHeight = pagerPrevElement.height() + parseInt( pagerPrevElement.css('border-top-width') ) + parseInt( pagerPrevElement.css('border-bottom-width') );
					var pagerNextHeight = pagerNextElement.height() + parseInt( pagerNextElement.css('border-top-width') ) + parseInt( pagerNextElement.css('border-bottom-width') );
					pagerPrevElement.css({ 'margin-top' : pagerElement.height() / 2 - pagerPrevHeight / 2 });
					pagerNextElement.css({ 'margin-top' : pagerElement.height() / 2 - pagerNextHeight / 2 });
				}
	
	
	
				// ページャーのスライド機能を使用する場合
				if ( settings.pagerSlide ) {
	
					var pagerElementWidth = parseInt( pagerElement.css('width') );
	
					// メインエレメントの子liの横幅
					if ( !settings.pagerListWidth )	{	// 0の場合はmainElementの幅（100%）
	
						pager.listWidth = pagerElementWidth;
	
					} else {							// 設定があれば
						pager.listWidth = settings.pagerListWidth;
						//pager.leftIndent = ( pagerElementWidth - pager.listWidth ) / 2;
						pager.leftIndent = 0;
					}
	
					pagerRightEndLimit = -pager.listWidth * ( listCount - 1 );
					pagerClearSpace = ( pager.listWidth * settings.spaceRange ); // フリック時の左右のゆとり
	
					pagerContainer.css({ width : pager.listWidth * listCount });
	
					// 横座標　式
					var abscissaPager = pager.leftIndent + -pager.listWidth * pager.connectCount;
	
					if ( css3AnimationSupport ) {	// css3Animationが使用できる場合
	
						var css = {};
	
						// アニメーション中じゃなければ無駄なトランジションを消してアニメーションさせない
						if ( !main.transform ) css[ css3Animation.transition ] = 'none';
						css[ css3Animation.transform ] = 'translate3d( '+ abscissaPager +'px, 0, 0 )';
	
						pagerContainer.css( css );
	
					} else {						// 古いブラウザ等、非対応の場合
	
						pagerContainer.css({ left : abscissaPager });
					}
	
					pagerListContainer.css({ width : pager.listWidth - pagerOuterWidth });
					pagerElement.css({ height : pagerContainer.height() }); // 縦幅の最大値
				}
			}
	
	
	
			// アニメーションの多重処理防止フラグ関連　css3Animation使用可能な場合でtransitionend時
			if ( css3Animation.transitionend ) {
	
				// リサイズ時のアニメーションを抑制
				mainContainer.bind( css3Animation.transitionend, function(){
	
					main.transform = false;			// アニメーションが完了したらフラグを消す
				});
	
				// ページャーのスライド機能を使用する場合
				if ( settings.pagerSlide ) {
	
					// リサイズ時のアニメーションを抑制
					pagerContainer.bind( css3Animation.transitionend, function(){
	
						pager.transform = false;	// アニメーションが完了したらフラグを消す
					});
				}
			}
	
	
	
	
	
			/*
			 * フリック、マウススライド処理
			 -----------------------------------------------------*/
			 var events = {
	
			 	touchstart : function(e){
	
			 		this.touched = true;
	
					// ※Android 4.0は、touchstart, touchmove で、event.preventDefault() を実行しないと、touchendは実行されない
					// http://www.gravitypianist.info/android-40touchend
					yFlag = false;
	
					var touches = touchable ? e.originalEvent.touches[0] : e;
	
					this.pageX = touches.clientX;	// 開始座標
					this.xBegin = -e.data.listWidth * e.data.connectCount;
					this.x = this.xBegin;
	
					this.pageY = touches.clientY;	// 開始座標
	
					this.startX = this.pageX;
					this.startY = this.pageY;
	
					// タイマー設定の場合のストップ処理
					if( settings.timer ) {
	
						runningTimer = false;
						time = 0;
						elements.stopTime();
					}
	
					if( e.data.name == "pager" && settings.pagerSlide ) pagerListContainer.bind( 'click', pagerRelease );
	
					if( settings.debug ) debug( this, "タッチ" );
	
					// PC版は画像ドラッグでthis.touchedがtrueのままになるのでフォーカスを奪われないようにする
					if( terminal == "pc" ) return false;
				},
	
				touchmove : function(e){
	
					if( !this.touched ){	// 過剰動作の防止
						return;
					}
	
					// animateの場合、前回の処理が終わる前に操作すると多重処理になるので停止させる
					if ( !css3AnimationSupport ) $(this).stop();
	
					var touches = touchable ? e.originalEvent.touches[0] : e;
	
					this.x = this.x - ( this.pageX - touches.clientX );
	
					if( e.data.name == "pager" && settings.pagerSlide ) e.data.moveSpeed = ( touches.clientX - this.pageX ) * 10;	// touchmoveの移動速度を割り出す
	
					this.pageX = touches.clientX;
					this.pageY = touches.clientY;
	
					// 移動距離計算
					this.distanceX = this.pageX - this.startX;
					this.distanceY = this.pageY - this.startY;
	
					// フリック、スワイプ感知フラグ
					if ( !xFlag && Math.abs( this.distanceY ) - Math.abs( this.distanceX ) > settings.verticalSensingRange ) {	// 垂直判定
	
						yFlag = true;
					}
	
					if ( !yFlag && Math.abs( this.distanceX ) - Math.abs( this.distanceY ) > 0 ) {			// 水平判定
	
						xFlag = true;
	
						e.preventDefault();	// スクロールを停止して以下を実行
	
						// 横座標
						var abscissa;
														// メインは移動量補正　式
														if ( e.data.name == "main" )		abscissa = e.data.leftIndent + this.x * settings.movementCorrection - e.data.listWidth * ( 1 - settings.movementCorrection ) * e.data.connectCount;
						else if ( settings.pagerSlide )	abscissa = e.data.leftIndent + this.x;	// 無段階スライドの場合は補正しない
	
						if ( css3AnimationSupport ) {	// css3Animationが使用できる場合
	
							var css = {};
	
							css[ css3Animation.transition ] = 'none';
							css[ css3Animation.transform ] = 'translate3d( '+ abscissa +'px, 0, 0 )';
	
							$(this).css( css );
	
						} else {						// 古いブラウザ等、非対応の場合
	
							$(this).css({ left: abscissa });
						}
					}
	
					if( settings.debug ) debug( this, "move" );
				},
	
				// ※Android 4.0は、touchstart, touchmove で、event.preventDefault() を実行しないと、touchendは実行されない
				// http://www.gravitypianist.info/android-40touchend
	
				// mouseoutは子要素にも反応してしまう
				// mouseenter/mouseleaveであれば子要素のイベントは発生しないがmouseleaveはIE6,7,8は対応していない
				//'touchend mouseup mouseout': function(e){
					touchend : function(e){
	
					if ( !this.touched ) {	// 過剰動作の防止
						return;
					}
	
					e.data( this );
				}
			};
	
	
			// イベント登録
			if ( touchable ) {
	
				mainContainer
				.bind( 'touchstart', main,             events.touchstart )
				.bind( 'touchmove',  main,             events.touchmove )
				.bind( 'touchend',   mainSlideRelease, events.touchend );
	
			} else {
	
				mainContainer
				.bind( 'mousedown',  main,             events.touchstart )
				.bind( 'mousemove',  main,             events.touchmove )
				.bind( 'mouseup',    mainSlideRelease, events.touchend );
			}
	
			// mouseout代用対策 // 将来的にreleaseOutside処理を作った方が良いがとりあえず
			mainContainer.hover(
	
				function(){	// over
	
					// hover時にタイマーを止める場合（SPはtouchstart時に停止させるので不要　※SPも実行するとタイマーが永遠に停止するためPCのみにする）
					if ( terminal == "pc" && settings.hoverStopTimer ) {
	
						runningTimer = false;
						elements.stopTime();
	
						if( settings.debug ) debug( {}, "タイマーストップ" );
					}
				},
	
				function(){	// out
	
					if( settings.timer ) autoSlideTimer();
	
					if ( this.touched ) {
	
						mainSlideRelease( this );
					}
				}
				);
	
	
	
			// release処理　'touchend mouseup'とhover()が同一処理なのでファンクション化
			function mainSlideRelease( target ){
	
				target.touched = false;
	
				if ( xFlag ) {
	
					var pagerListContainerActive = pagerContainer.children( "li." + settings.selectedClassName );
	
					// 右
					if ( target.xBegin > target.x && !( target.xBegin === mainRightEndLimit ) ) {
	
						// ゆとり　mainClearSpace未満で放した場合は元に戻す
						if( target.xBegin - mainClearSpace < target.x ) {
	
						} else {
	
							main.connectCount ++;
	
							if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
	
							pagerListContainerActive.removeClass( settings.selectedClassName );
							pagerListContainerActive.next().addClass( settings.selectedClassName );
	
							if ( settings.pagerSlide ) {
	
								pager.connectCount = main.connectCount;
								animationMove( pager );
							}
						}
	
					// 左
				} else if ( target.xBegin < target.x && !( target.xBegin === 0 ) ) {
	
						// ゆとり　mainClearSpace未満で放した場合は元に戻す
						if( target.xBegin + mainClearSpace > target.x ) {
	
						} else {
	
							main.connectCount --;
	
							if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
	
							pagerListContainerActive.removeClass( settings.selectedClassName );
							pagerListContainerActive.prev().addClass( settings.selectedClassName );
	
							if ( settings.pagerSlide ) {
	
								pager.connectCount = main.connectCount;
								animationMove( pager );
							}
						}
					}
				}
	
				if ( xFlag ) animationMove( main );
	
				yFlag = false;	// スクロール感知
				xFlag = false;	// スライド感知
	
				// タイマー　hoverストップ設定でなければRelease後にスタート
				if ( settings.hoverStopTimer && settings.timer ) autoSlideTimer();
	
				if( settings.debug ) debug( target, "release" );
			}
	
	
	
			//-----------------------------------------------------
	
	
	
			// ページャーが存在する場合
			if ( setPager ) {
	
				// mouseout代用対策 // 将来的にreleaseOutside処理を作った方が良いがとりあえず
				pagerContainer.hover(
	
					function(){	// over
	
						// hover時にタイマーを止める場合（SPはtouchstart時に停止させるので不要　※SPも実行するとタイマーが永遠に停止するためPCのみにする）
						if ( terminal == "pc" && settings.hoverStopTimer ) {
	
							runningTimer = false;
							elements.stopTime();
	
							if( settings.debug ) debug( {}, "タイマーストップ" );
						}
					},
	
					function(){	// out
	
						if( settings.timer ) autoSlideTimer();
	
						if ( this.touched ) {
	
							pagerSlideRelease( this );
						}
					}
					);
			}
	
			// ページャーのスライド機能を使用する場合
			if ( settings.pagerSlide ) {
	
				// イベント登録
				if ( touchable ) {
	
					pagerContainer
					.bind( 'touchstart', pager,             events.touchstart )
					.bind( 'touchmove',  pager,             events.touchmove )
					.bind( 'touchend',   pagerSlideRelease, events.touchend );
	
				} else {
	
					pagerContainer
					.bind( 'mousedown',  pager,             events.touchstart )
					.bind( 'mousemove',  pager,             events.touchmove )
					.bind( 'mouseup',    pagerSlideRelease, events.touchend );
				}
	
	
			}
	
			// release処理　'touchend mouseup'とhover()が同一処理なのでファンクション化
			function pagerSlideRelease( target ){
	
				target.touched = false;
	
				if ( xFlag ) {
	
					// 右
					if ( target.xBegin > target.x && !( target.xBegin === pagerRightEndLimit ) ) {
	
						// ゆとり　pagerClearSpace未満で放した場合は元に戻す
						if( target.xBegin - pagerClearSpace < target.x ) {
	
						} else {
	
							pager.flickX = target.xBegin - target.x - pager.moveSpeed;
	
							for ( var i = pager.listWidth / 2; i < pager.flickX; i += pager.listWidth ) {
	
								pager.connectCount ++;
	
								if ( pager.connectCount >= listCount - 1 ) break;
							}
	
							if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
						}
	
					// 左
				} else if ( target.xBegin < target.x && !( target.xBegin === 0 ) ) {
	
						// ゆとり　pagerClearSpace未満で放した場合は元に戻す
						if( target.xBegin + pagerClearSpace > target.x ) {
	
						} else {
	
							pager.flickX = target.xBegin - target.x - pager.moveSpeed;
	
							for ( var i = -pager.listWidth / 2; i > pager.flickX; i -= pager.listWidth ) {
	
								pager.connectCount --;
	
								if ( pager.connectCount <= 0 ) break;
							}
	
							if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
						}
					}
				}
	
				if ( xFlag ) {	// イベントハンドラを削除してアニメーション
	
					pagerListContainer.unbind( 'click' );
					animationMove( pager );
				}
	
				yFlag = false;	// スクロール感知
				xFlag = false;	// スライド感知
	
				// タイマー　hoverストップ設定でなければRelease後にスタート
				if ( !settings.hoverStopTimer && settings.timer ) autoSlideTimer();
	
				if( settings.debug ) debug( target, "release" );
			}
	
	
	
			/*
			 * ページャーボタン処理
			 -----------------------------------------------------*/
			 function pagerRelease(){
	
				// main
				main.connectCount = pagerListContainer.index(this);
				animationMove( main );
	
				if( ( setMainNeighbors || setPagerNeighbors ) && !settings.repeat ) neighborsSetDisabled();
	
	
				// pager
				if ( pagerContainer.length ) {
					pagerListContainer.removeClass( settings.selectedClassName );
					$(this).addClass( settings.selectedClassName );
				}
	
				// ページャーのスライド機能を使用する場合
				if ( settings.pagerSlide ) {
	
					pager.connectCount = main.connectCount;
					animationMove( pager );
				}
	
	
				// time
				time = 0;
	
	
				if( settings.debug ) debug( {}, "ページャー移動" );
			}
	
			// ページャーが存在し静止ページャーの場合
			if ( setPager && !settings.pagerSlide ) {
	
				pagerListContainer.bind( 'click', pagerRelease );
			}
	
	
	
	
	
			/*
			 * ネイバーズボタン関連
			 -----------------------------------------------------*/
	
			// メインエレメントにprev、nextボタンが存在する場合
			if ( setMainNeighbors ) {
	
				mainPrevElement.click( function(){ mainNeighborsSwitch( main, -1 ); } );
				mainNextElement.click( function(){ mainNeighborsSwitch( main, 1 ); });
			}
	
			// ページャーエレメントにprev、nextボタンが存在する場合
			if ( setPagerNeighbors ) {
	
				pagerPrevElement.click( function(){ mainNeighborsSwitch( main, -1 ); } );
				pagerNextElement.click( function(){ mainNeighborsSwitch( main, 1 ); } );
				//pagerPrevElement.click( function(){ pagerNeighborsSwitch( pager, -1 ); } );
				//pagerNextElement.click( function(){ pagerNeighborsSwitch( pager, 1 ); } );
			}
	
	
	
			// ネイバーズボタン処理
			function mainNeighborsSwitch( variableObject, value ){
	
				neighborsMove( variableObject, value );
	
				// ページャーのスライド機能を使用する場合
				if ( settings.pagerSlide ) {
	
					pager.connectCount = main.connectCount;
					animationMove( pager );
				}
	
				//if( settings.debug ) debug( {}, "メインネイバーズボタン移動" );
			}
			/*
			function pagerNeighborsSwitch( variableObject, value ){
	
				neighborsMove( variableObject, value );
	
				main.connectCount = pager.connectCount;
				animationMove( main );
	
				if( settings.debug ) debug( {}, "ページャーネイバーズボタン移動" );
			}
			*/
	
	
			// ネイバーズボタン　スライド処理
			function neighborsMove( variableObject, value ){
	
				variableObject.connectCount += value;
				time = 0;
	
				if( settings.repeat ) {	// 繰り返し設定の場合
	
					if( variableObject.connectCount < 0 ){
	
						variableObject.connectCount = listCount - 1;
	
					} else if ( variableObject.connectCount > listCount - 1 ){
	
						variableObject.connectCount = 0;
					}
	
				} else {	// 繰り返し設定がない場合はリミット
	
					if( variableObject.connectCount < 0 ){
	
						variableObject.connectCount = 0;
	
					} else if ( variableObject.connectCount > listCount - 1 ){
	
						variableObject.connectCount = listCount - 1;
					}
	
					if( setMainNeighbors || setPagerNeighbors ) neighborsSetDisabled();
				}
	
				animationMove( variableObject );
	
				if ( pagerContainer.length ) {
					pagerListContainer.removeClass( settings.selectedClassName );
					pagerListContainer.eq( variableObject.connectCount ).addClass( settings.selectedClassName );
				}
	
				if( settings.debug ) debug( {}, "ネイバーズボタンスライド処理" );
			}
	
	
	
			// ネイバーズボタン　無効用class処理
			function neighborsSetDisabled(){
	
				if( main.connectCount <= 0 ){
	
					if ( setMainNeighbors ) {
	
						mainPrevElement.addClass( settings.disabledClassName );
						mainNextElement.removeClass( settings.disabledClassName );
					}
	
					if ( setPagerNeighbors ) {
	
						pagerPrevElement.addClass( settings.disabledClassName );
						pagerNextElement.removeClass( settings.disabledClassName );
					}
	
				} else if ( main.connectCount >= listCount - 1 ){
	
					if ( setMainNeighbors ) {
	
						mainPrevElement.removeClass( settings.disabledClassName );
						mainNextElement.addClass( settings.disabledClassName );
					}
	
					if ( setPagerNeighbors ) {
	
						pagerPrevElement.removeClass( settings.disabledClassName );
						pagerNextElement.addClass( settings.disabledClassName );
					}
	
				} else {
	
					if ( setMainNeighbors ) {
	
						mainPrevElement.removeClass( settings.disabledClassName );
						mainNextElement.removeClass( settings.disabledClassName );
					}
	
					if ( setPagerNeighbors ) {
	
						pagerPrevElement.removeClass( settings.disabledClassName );
						pagerNextElement.removeClass( settings.disabledClassName );
					}
				}
			}
	
	
	
	
	
			/*
			 * アニメーションスライド処理
			 -----------------------------------------------------*/
			 function animationMove( variableObject ){
	
				// 横座標　式
				var abscissa = variableObject.leftIndent + -variableObject.listWidth * variableObject.connectCount;
				//main.abscissa = abscissa;
				if ( css3AnimationSupport ) {	// css3Animationが使用できる場合
	
					variableObject.transform = true;	// アニメーションの多重処理防止用にフラグを立てる
	
					var css = {};
	
					var duration;
	
					if ( variableObject.name == "main" ) {
	
						duration = settings.slideSpeed;
	
					} else {	// 無段階スライドの場合はスピード分加算する
	
						duration = settings.slideSpeed + Math.abs( variableObject.moveSpeed / 2 );
						variableObject.moveSpeed = 0;	// 数値が残ると外部からの操作も速度が残るので初期化
					}
	
					css[ css3Animation.transition ] = css3Animation.transform +' '+ duration +'ms '+ settings.transitionEasing;
					css[ css3Animation.transform ] = 'translate3d( '+ abscissa +'px, 0, 0 )';
	
					variableObject.element.css( css );
	
				} else {								// 古いブラウザ等、非対応の場合
	
					variableObject.element.stop().animate( { left: abscissa }, { duration: settings.slideSpeed, easing: settings.jqueryEasing } );
				}
			}
	
	
	
	
	
			/*
			 * 自動スライドタイマー　settings.timerが1以上の場合の処理
			 -----------------------------------------------------*/
			 function autoSlideTimer() {
	
			 	if( !runningTimer ) {
	
					runningTimer = true;	// タイマーの多重処理防止用にフラグを立てる
	
					elements.everyTime( 100, 'timer', function() {
	
						time ++;
	
						if( time / 10 >= settings.timer ) {
	
							mainNeighborsSwitch( main, 1 );
							/*
							if ( settings.pagerSlide ) {
	
								pagerNeighborsSwitch( pager, 1 );
							}*/
						}
	
						if( settings.debug ) debug( {}, "タイマー" );
					});
				}
			}
	
			if( settings.timer ) autoSlideTimer();
	
	
	
	
	
			/*
			// 選択状態を解除する
			function deSelect() {
	
				if (window.getSelection) {
	
					var selection = window.getSelection();
					selection.collapse(document.body, 0);
	
				} else {	// IE
	
					var selection = document.selection.createRange();
					selection.setEndPoint("EndToStart", selection);
					selection.select();
				}
			}
			*/
	
	
	
	
	
			/*
			 * デバッグ
			 -----------------------------------------------------*/
			// ※IE8以下はobjectプロパティがundefinedの場合中断されるので注意　IE8以下ではデバッグしない方が良い
	
			// settings.debugがtrueの場合はデバッグ用エレメントを生成
			if( settings.debug ) {
	
				$( elements ).append('<div class="debug">待機</div>');
				var debugElement = elements.children("div.debug");
			}
	
			// デバッグ出力処理
			function debug( object, str ) {
	
				if ( settings.pagerSlide ) {
	
					// ※IE8以下中断注意
					var pagerStr =
	
					"moveSpeed ="+ pager.moveSpeed +"<br>"+
					"pager.connectCount = "+ pager.connectCount +"<br>"+
					"<br>"+
					"<dl>"+
					"<dt>pagerMarginWidth = </dt><dd>"+ pagerMarginWidth +"</dd>"+
					"<dt>pagerPaddingWidth = </dt><dd>"+ pagerPaddingWidth +"</dd>"+
					"<dt>pagerBorderWidth = </dt><dd>"+ pagerBorderWidth +"</dd>"+
					"<dt>pagerOuterWidth = </dt><dd>"+ pagerOuterWidth +"</dd>"+
					"</dl>"+
					"<br>"+
					"pagerListContainer = "+ parseInt( pagerListContainer.css('width') ) +" + "+ pagerOuterWidth +" ( "+ pager.listWidth +" )<br>"
					;
				}
	
				if ( !$.isEmptyObject( object ) ) {
	
					var objectStr =
	
					"touched = "+ object.touched +"<br>"+
					"X移動量 = "+ object.distanceX +" / startX = "+ object.startX +"<br>"+
					"Y移動量 = "+ object.distanceY +" / startY = "+ object.startY +"<br>"+
					"xFlag = "+ xFlag +" / yFlag = "+ yFlag +"<br>"
					;
				}
	
				debugElement.html(
	
					//"test = "+ pager.flickX +" "+ object.xBegin +" "+ object.x +"<br>"+
					//pager.flickX +" / "+ pager.listWidth +"<br>"+
					"strUserAgent = "+ strUserAgent +"<br>"+
					"<br>"+
					"runningTimer = "+ runningTimer +"<br>"+
					"time = "+ time +"<br>"+
					"main.connectCount = "+ main.connectCount +"<br>"+
					"<br>"+
					"listCount = "+ listCount +"<br>"+
					"totalWidth = "+ ( main.listWidth * listCount ) +"<br>"+
					"listInner = "+ ( main.listWidth - mainMarginWidth - mainPaddingWidth ) +"<br>"+
					"main.leftIndent = "+ main.leftIndent +"<br>"+
					//"<br>"+
					//"UL = "+ ( ( main.listWidth - mainMarginWidth - mainPaddingWidth ) * main.connectCount ) +" - "+ main.leftIndent +" = "+ parseInt( mainContainer.css('left') ) +"<br>"+
					"<br>"+
					"mainElement = "+ parseInt( mainElement.css('width') ) +"<br>"+
					"mainContainer = "+ parseInt( mainContainer.css('width') ) +"<br>"+
					"<br>"+
					"<dl>"+
					"<dt>mainMarginWidth = </dt><dd>"+ mainMarginWidth +"</dd>"+
					"<dt>mainPaddingWidth = </dt><dd>"+ mainPaddingWidth +"</dd>"+
					"<dt>mainBorderWidth = </dt><dd>"+ mainBorderWidth +"</dd>"+
					"<dt>mainOuterWidth = </dt><dd>"+ mainOuterWidth +"</dd>"+
					"</dl>"+
					"<br>"+
					"mainListContainer = "+ parseInt( mainListContainer.css('width') ) +" + "+ mainOuterWidth +" ( "+ main.listWidth +" )<br>"+
					"<br>"+
					pagerStr +
					"<br>"+
					"css3AnimationSupport = "+ css3AnimationSupport +"<br>"+
					"opacity = "+ settings.opacity +"<br>"+
					"<br>"+
	
					objectStr +
					"<br>"+
	
					"ステータス = "+ str +"<br>"
					);
	}
	
			// method chainが途切れないように、最後にreturn thisを書く
			return this;
		};
	
	})(jQuery);


/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * jQuery Skitter Slideshow
	 * @name jquery.skitter.js
	 * @description Slideshow
	 * @author Thiago Silva Ferreira - http://thiagosf.net
	 * @version 3.9
	 * @date August 04, 2010
	 * @update April 07, 2012
	 * @copyright (c) 2010 Thiago Silva Ferreira - http://thiagosf.net
	 * @license Dual licensed under the MIT or GPL Version 2 licenses
	 * @example http://thiagosf.net/projects/jquery/skitter/
	 */
	eval(function(p,a,c,k,e,r){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('(q($){f 2G=0,5x=[];$.2f.3R=q(F){11 c.3w(q(){$(c).7W(\'7X\',2G);5x.5y(2w $32(c,F,2G));++2G})};f 5z={1e:1,2x:7Y,3S:\'\',3T:S,3U:S,2n:S,Q:\'\',k:1A,7Z:1A,1j:1A,1w:1A,1R:1A,33:1A,3V:\'4H\',w:1A,M:1A,1x:1,1b:R,2P:R,3W:1A,5A:R,3X:R,3x:{4I:\'#81\',3Y:\'#4J\'},4K:{4I:\'#4J\',3Y:\'#82\'},3Z:{4I:\'#83\',3Y:\'#4J\'},2g:R,41:R,34:R,3y:R,3z:1A,1U:0.75,2y:2z,2H:1L,4L:1A,4M:1A,84:20,4N:\'r\',35:R,2A:R,2Q:R,4O:\'42\',2R:R,4P:\'42\',1E:R,2h:{},2o:R,36:R,3a:R,44:0,23:0,3b:S,5B:R,45:[],5C:q(){$(c).1M().H({O:0.5},1s)},5D:q(){$(c).1M().H({O:1},1s)},46:S,5E:\'<a 1O="#" 1u="24">85</a>\'+\'<a 1O="#" 1u="1V">86</a>\'+\'<2I 1u="1B"></2I>\'+\'<1o 1u="47">\'+\'<1o 1u="1N">\'+\'<a 1O=""><V 1u="1i" /></a>\'+\'<1o 1u="2J"></1o>\'+\'</1o>\'+\'</1o>\'};$.3R=q(3A,F,5F){c.k=$(3A);c.2S=1A;c.g=$.1W({},5z,F||{});c.2G=5F;c.5G()};f $32=$.3R;$32.2f=$32.4Q={};$32.2f.1W=$.1W;$32.2f.1W({5G:q(){f h=c;n(c.g.41){f E=$(2T).E();f I=$(2T).I();c.k.E(E).I(I);c.k.A({\'2p\':\'4R\',\'t\':0,\'r\':0,\'z-5H\':4S});c.g.3b=R;$(\'4T\').A({\'87\':\'88\'})}c.g.w=3c(c.k.A(\'E\'));c.g.M=3c(c.k.A(\'I\'));n(!c.g.w||!c.g.M){89.8a(\'8b 5I I 48 5J 1A! - 8c 8d\');11 R}c.k.1F(c.g.5E);c.g.Q=c.5K(c.g.J);n(c.g.1e>=2)c.g.1e=1.3;n(c.g.1e<=0)c.g.1e=1;c.k.j(\'.1B\').1g();c.k.j(\'.2J\').1g();c.k.j(\'.24\').1g();c.k.j(\'.1V\').1g();c.k.j(\'.47\').E(c.g.w);c.k.j(\'.47\').I(c.g.M);f 3z=c.g.3z?c.g.3z:c.g.w;c.k.j(\'.2J\').E(3z);f 49=\' 2U\',u=0;c.g.1j=2w 4a();f 4U=q(2K,X,1X,2n,2i){h.g.1j.5y([X,2K,1X,2n,2i]);n(h.g.3X){f 4b=\'\';n(h.g.w>h.g.M){4b=\'I="1v"\'}17{4b=\'E="1v"\'}h.k.j(\'.1B\').1F(\'<2I 1u="1S\'+49+\'" 3d="\'+(u-1)+\'" 4c="4V\'+u+\'4W\'+h.2G+\'">\'+\'<V X="\'+X+\'" \'+4b+\' />\'+\'</2I> \')}17{h.k.j(\'.1B\').1F(\'<2I 1u="1S\'+49+\'" 3d="\'+(u-1)+\'" 4c="4V\'+u+\'4W\'+h.2G+\'">\'+u+\'</2I> \')}49=\'\'};n(c.g.34){$.8e({5L:\'8f\',5M:c.g.34,8g:R,8h:\'34\',8i:q(34){f 2q=$(\'<2q></2q>\');$(34).j(\'3R 8j\').3w(q(){++u;f 2K=($(c).j(\'2K\').3e())?$(c).j(\'2K\').3e():\'#\';f X=$(c).j(\'1N\').3e();f 1X=$(c).j(\'1N\').U(\'5L\');f 2n=$(c).j(\'2n\').3e();f 2i=($(c).j(\'2i\').3e())?$(c).j(\'2i\').3e():\'4H\';4U(2K,X,1X,2n,2i)})}})}17 n(c.g.8k){}17{c.k.j(\'2q 3f\').3w(q(){++u;f 2K=($(c).j(\'a\').1y)?$(c).j(\'a\').U(\'1O\'):\'#\';f X=$(c).j(\'V\').U(\'X\');f 1X=$(c).j(\'V\').U(\'1u\');f 2n=$(c).j(\'.8l\').2V();f 2i=($(c).j(\'a\').1y&&$(c).j(\'a\').U(\'2i\'))?$(c).j(\'a\').U(\'2i\'):\'4H\';4U(2K,X,1X,2n,2i)})}n(h.g.3X&&!h.g.41){h.g.3x={O:0.3};h.g.4K={O:0.5};h.g.3Z={O:1};h.k.j(\'.1B\').3B(\'2B\');f 4d=(u+1)*h.k.j(\'.2B .1S\').E();h.k.j(\'.2B\').E(4d);h.k.A({I:h.k.I()+h.k.j(\'.1B\').I()});h.k.1F(\'<1o 1u="5N"></1o>\');f 5O=h.k.j(\'.1B\').8m();h.k.j(\'.1B\').2C();h.k.j(\'.5N\').E(h.g.w).1F(5O);f 4X=0,w=c.g.w,M=c.g.M,3C=0,2B=h.k.j(\'.2B\'),4Y=0,5P=h.k.3g().t;2B.j(\'.1S\').3w(q(){4X+=$(c).8n()});2B.E(4X+\'Z\');3C=2B.E();4e=c.g.w;4e=w-1v;n(4d>h.g.w){h.k.8o(q(e){4Y=h.k.3g().r+90;f x=e.8p,y=e.8q,2W=0;x=x-4Y;y=y-5P;5Q=3C-4e;2W=-((5Q*x)/4e);n(2W>0)2W=0;n(2W<-(3C-w))2W=-(3C-w);n(y>M){2B.A({r:2W})}})}h.k.j(\'.8r\').A({\'r\':10});n(4d<h.g.w){h.k.j(\'.1B\').E(\'2X\');h.k.j(\'.8s\').1g();f 1P=\'.1B\';2L(h.g.4N){N\'42\':f 18=(h.g.w-h.k.j(1P).E())/2;h.k.j(1P).A({\'r\':18});L;N\'2r\':h.k.j(1P).A({\'r\':\'2X\',\'2r\':\'-8t\'});L;N\'r\':h.k.j(1P).A({\'r\':\'8u\'});L}}}17{f 1P=\'.1B\';n(h.g.3y){h.k.j(\'.1B\').3B(\'4Z\').51(\'1B\');1P=\'.4Z\'}2L(h.g.4N){N\'42\':f 18=(h.g.w-h.k.j(1P).E())/2;h.k.j(1P).A({\'r\':18});L;N\'2r\':h.k.j(1P).A({\'r\':\'2X\',\'2r\':\'5R\'});L;N\'r\':h.k.j(1P).A({\'r\':\'5R\'});L}n(!h.g.3y){n(h.k.j(\'.1B\').I()>20){h.k.j(\'.1B\').1g()}}}c.k.j(\'2q\').1g();n(c.g.5A)c.g.1j.5S(q(a,b){11 C.1k()-0.5});c.g.1w=c.g.1j[0][0];c.g.1R=c.g.1j[0][1];c.g.33=c.g.1j[0][3];c.g.3V=c.g.1j[0][4];n(c.g.1j.1y>1){c.k.j(\'.24\').2D(q(){n(h.g.1b==R){h.g.1x-=2;n(h.g.1x==-2){h.g.1x=h.g.1j.1y-2}17 n(h.g.1x==-1){h.g.1x=h.g.1j.1y-1}h.4f(h.g.1x)}11 R});c.k.j(\'.1V\').2D(q(){h.4f(h.g.1x);11 R});h.k.j(\'.1V, .24\').4g(\'52\',h.g.5C);h.k.j(\'.1V, .24\').4g(\'5T\',h.g.5D);c.k.j(\'.1S\').5U(q(){n($(c).U(\'1u\')!=\'1S 2U\'){$(c).1M().H(h.g.4K,2z)}},q(){n($(c).U(\'1u\')!=\'1S 2U\'){$(c).1M().H(h.g.3x,1L)}});c.k.j(\'.1S\').2D(q(){n($(c).U(\'1u\')!=\'1S 2U\'){f 4h=3h($(c).U(\'3d\'));h.4f(4h)}11 R});c.k.j(\'.1S\').A(h.g.3x);c.k.j(\'.1S:8v(0)\').A(h.g.3Z);n(h.g.35&&h.g.3y){f 35=$(\'<1o 1u="4i"><2q></2q></1o>\');1f(f i=0;i<c.g.1j.1y;i++){f 3f=$(\'<3f></3f>\');f V=$(\'<V />\');V.U(\'X\',c.g.1j[i][0]);3f.1F(V);35.j(\'2q\').1F(3f)}f 5V=3h(c.g.1j.1y*1v);35.j(\'2q\').E(5V);$(1P).1F(35);h.k.j(1P).j(\'.1S\').8w(q(){f 5W=3c(h.k.j(1P).3g().r);f 5X=3c($(c).3g().r);f 5Y=(5X-5W)-43;f 3d=3h($(c).U(\'3d\'));f 8x=h.k.j(\'.8y V\').U(\'X\');f 5Z=-(3d*1v);h.k.j(\'.4i\').j(\'2q\').H({r:5Z},{4j:1s,3i:R,J:\'60\'});h.k.j(\'.4i\').2s(1,1).H({r:5Y},{4j:1s,3i:R})});h.k.j(1P).5T(q(){$(\'.4i\').H({O:\'1g\'},{4j:1s,3i:R})})}}n(h.g.2A){h.61()}n(h.g.2R){h.62()}n(h.g.1E&&h.g.46){h.63()}n(h.g.2g){h.2g()}n(h.g.5B){h.64()}c.65()},65:q(){f h=c;f 2t=$(\'<1o 1u="2t">8z</1o>\');c.k.1F(2t);f s=c.g.1j.1y;f u=0;$.3w(c.g.1j,q(i){f 66=c;f 2t=$(\'<2I 1u="4k"></2I>\');2t.A({2p:\'4R\',t:\'-8A\'});h.k.1F(2t);f V=2w 8B();$(V).8C(q(){++u;n(u==s){h.k.j(\'.2t\').2C();h.k.j(\'.4k\').2C();h.67()}}).8D(q(){h.k.j(\'.2t, .4k, .1S, .1V, .24\').2C();h.k.2V(\'<p 26="3Y:8E;4l:8F;">8G 2t 68. 8H 5I 8I 68 8J 8K 8L.</p>\')}).U(\'X\',66[0])})},67:q(){f h=c;f 53=R;n(c.g.3T||c.g.3X)c.k.j(\'.1B\').3D(1L);n(c.g.3y)c.k.j(\'.4Z\').3D(1L);n(c.g.2n)c.k.j(\'.2J\').T();n(c.g.3U){c.k.j(\'.24\').3D(1L);c.k.j(\'.1V\').3D(1L)}h.3E();h.69();h.28();h.k.j(\'.1N a V\').U({\'X\':h.g.1w});4m=h.k.j(\'.1N a\');4m=h.4n(4m);4m.j(\'V\').3D(8M);h.54();h.55();n(h.g.46){h.6a()}f 56=q(){n(h.g.3b){53=S;h.g.2P=S;h.2E(S);h.57()}};h.k.52(56);h.k.j(\'.1V\').52(56);n(h.g.1j.1y>1&&!53){n(h.g.46){h.2S=3F(q(){h.4o()},h.g.2x)}}17{h.k.j(\'.2t, .4k, .1S, .1V, .24\').2C()}n($.6b(h.g.4L))h.g.4L()},4f:q(4h){n(c.g.1b==R){c.g.23=0;c.k.j(\'.l\').1M();c.2E(S);c.g.1x=C.6c(4h);c.k.j(\'.1N a\').U({\'1O\':c.g.1R});c.k.j(\'.1i\').U({\'X\':c.g.1w});c.k.j(\'.l\').2C();c.4o()}},4o:q(){f h=c;3G=[\'6d\',\'6e\',\'6f\',\'6g\',\'6h\',\'6i\',\'6j\',\'6k\',\'6l\',\'6m\',\'6n\',\'6o\',\'6p\',\'6q\',\'6r\',\'6s\',\'6t\',\'6u\',\'6v\',\'6w\',\'6x\',\'6y\',\'6z\',\'6A\',\'6B\',\'6C\',\'6D\',\'6E\',\'6F\',\'6G\',\'6H\',\'6I\',\'6J\'];n(h.g.1E)h.6K();1X=(c.g.3S==\'\'&&c.g.1j[c.g.1x][2])?c.g.1j[c.g.1x][2]:(c.g.3S==\'\'?\'3H\':c.g.3S);n(1X==\'8N\'){n(!c.g.3W){3G.5S(q(){11 0.5-C.1k()});c.g.3W=3G}1X=c.g.3W[c.g.1x]}17 n(1X==\'1k\'){f 6L=3h(C.1k()*3G.1y);1X=3G[6L]}17 n(h.g.45.1y>0){f 6M=h.g.45.1y;n(c.g.3j==1Y){c.g.3j=0}1X=h.g.45[c.g.3j];++c.g.3j;n(c.g.3j>=6M)c.g.3j=0}2L(1X){N\'6d\':c.58();L;N\'6e\':c.58({1k:S});L;N\'6f\':c.6N();L;N\'6g\':c.59();L;N\'6h\':c.59({1k:S});L;N\'6i\':c.6O();L;N\'6j\':c.6P();L;N\'6k\':c.6Q();L;N\'6l\':c.5a();L;N\'6m\':c.5a({1k:S});L;N\'6n\':c.5b();L;N\'6o\':c.6R();L;N\'6p\':c.6S();L;N\'6q\':c.6T();L;N\'6r\':c.6U();L;N\'6s\':c.5c({I:S});L;N\'6t\':c.5c({I:R,G:2Y,19:50});L;N\'6u\':c.3I({2j:\'t\'});L;N\'6v\':c.3I({2j:\'2Z\'});L;N\'6w\':c.3I({2j:\'2r\',s:5});L;N\'6x\':c.3I({2j:\'r\',s:5});L;N\'6y\':c.6V();L;N\'8O\':c.6W();L;N\'6z\':c.6X();L;N\'6A\':c.6Y();L;N\'6B\':c.6Z();L;N\'6C\':c.71();L;N\'6D\':c.72();L;N\'6E\':c.73();L;N\'6F\':c.5d({2j:\'t\'});L;N\'6G\':c.5d({2j:\'2Z\'});L;N\'6H\':c.74();L;N\'6I\':c.5e();L;N\'6J\':c.5e({J:\'5f\'});L;3H:c.5b();L}},58:q(F){f h=c;f F=$.1W({},{1k:R},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'31\':c.g.Q;f G=3k/c.g.1e;c.1p();f 1t=C.K(c.g.w/(c.g.w/8));f 1h=C.K(c.g.M/(c.g.M/3));f s=1t*1h;f v=C.K(c.g.w/1t);f B=C.K(c.g.M/1h);f 1c=c.g.M+1s;f 1d=c.g.M+1s;f W=0;f 13=0;1f(i=0;i<s;i++){1c=(i%2==0)?1c:-1c;1d=(i%2==0)?1d:-1d;f 1a=1c+(B*W)+(W*5g);f 18=-h.g.w;f 1q=-(B*W);f 1l=-(v*13);f Y=(B*W);f 14=(v*13);f l=c.1G();l.1g();f D=50*(i);n(F.1k){D=40*(13);l.A({r:18+\'Z\',t:1a+\'Z\',E:v,I:B})}17{G=1L;l.A({r:(c.g.w)+(v*i),t:c.g.M+(B*i),E:v,I:B})}c.1m(l);f P=(i==(s-1))?q(){h.1n()}:\'\';l.T().19(D).H({t:Y+\'Z\',r:14+\'Z\'},G,J,P);n(F.1k){l.j(\'V\').A({r:1l+1v,t:1q+50});l.j(\'V\').19(D+(G/2)).H({r:1l,t:1q},4S,\'5f\')}17{l.j(\'V\').A({r:1l,t:1q});l.j(\'V\').19(D+(G/2)).2s(1v,0.5).2s(2z,1)}W++;n(W==1h){W=0;13++}}},6N:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=1L/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/15));f v=C.K(c.g.w/s);f B=(c.g.M);1f(i=0;i<s;i++){f 14=(v*(i));f Y=0;f l=c.1G();l.A({r:c.g.w+1v,t:0,E:v,I:B});l.j(\'V\').A({r:-(v*i)});c.1m(l);f D=80*(i);f P=(i==(s-1))?q(){h.1n()}:\'\';l.T().19(D).H({t:Y,r:14},G,J);l.j(\'V\').1g().19(D+1v).H({O:\'T\'},G+2z,J,P)}},59:q(F){f h=c;f F=$.1W({},{1k:R},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'4p\':c.g.Q;f G=2z/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f 1t=C.K(c.g.w/(c.g.w/8));f 1h=C.K(c.g.M/(c.g.w/8));f s=1t*1h;f v=C.K(c.g.w/1t);f B=C.K(c.g.M/1h);f 1c=0;f 1d=0;f W=0;f 13=0;f 1H=c.g.w/16;1f(i=0;i<s;i++){1c=(i%2==0)?1c:-1c;1d=(i%2==0)?1d:-1d;f 1a=1c+(B*W);f 18=(1d+(v*13));f 1q=-(B*W);f 1l=-(v*13);f Y=1a-1H;f 14=18-1H;f l=c.2k(1r);l.A({r:18+\'Z\',t:1a+\'Z\',E:v,I:B});l.j(\'V\').A({r:1l,t:1q});c.1m(l);l.T();f D=50*i;n(F.1k){G=4S/c.g.1e;Y=1a;14=18;D=30*(C.1k()*30)}f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({O:\'1g\',t:Y+\'Z\',r:14+\'Z\'},G,J,P);W++;n(W==1h){W=0;13++}}},6O:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=1L/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f 1t=C.K(c.g.w/(c.g.w/8));f 1h=C.K(c.g.M/(c.g.M/3));f s=1t*1h;f v=C.K(c.g.w/1t);f B=C.K(c.g.M/1h);f 1c=0;f 1d=0;f W=0;f 13=0;1f(i=0;i<s;i++){1c=(i%2==0)?1c:-1c;1d=(i%2==0)?1d:-1d;f 1a=1c+(B*W);f 18=(1d+(v*13));f 1q=-(B*W);f 1l=-(v*13);f Y=1a-50;f 14=18-50;f l=c.2k(1r);l.A({r:18+\'Z\',t:1a+\'Z\',E:v,I:B});l.j(\'V\').A({r:1l,t:1q});c.1m(l);l.T();f D=50*i;D=(i==(s-1))?(s*50):D;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({O:\'1g\'},G,J,P);W++;n(W==1h){W=0;13++}}},6W:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'76\':c.g.Q;f G=2z/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f 1t=C.K(c.g.w/(c.g.w/8));f 1h=C.K(c.g.M/(c.g.M/3));f s=1t*1h;f v=C.K(c.g.w/1t);f B=C.K(c.g.M/1h);f 1c=0;f 1d=0;f W=0;f 13=0;f u=-1;1f(i=0;i<s;i++){n(13%2!=0){n(W==0){u=u+1h+1}u--}17{n(13>0&&W==0){u=u+2}u++}1c=(i%2==0)?1c:-1c;1d=(i%2==0)?1d:-1d;f 1a=1c+(B*W);f 18=(1d+(v*13));f 1q=-(B*W);f 1l=-(v*13);f Y=1a-50;f 14=18-50;f l=c.2k(1r);l.A({r:18+\'Z\',t:1a+\'Z\',E:v,I:B});l.j(\'V\').A({r:1l,t:1q});c.1m(l);l.T();f D=(50*i);f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({E:\'+=2u\',I:\'+=2u\',t:\'-=77\',r:\'-=77\',O:\'1g\'},G,J,P);W++;n(W==1h){W=0;13++}}},6P:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'4q\':c.g.Q;f G=78/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f 1t=C.K(c.g.w/(c.g.w/8));f 1h=C.K(c.g.M/(c.g.M/3));f s=1t*1h;f v=C.K(c.g.w/1t);f B=C.K(c.g.M/1h);f 1c=0;f 1d=0;f W=0;f 13=0;f 1H=C.K(c.g.w/6);1f(i=0;i<s;i++){1c=(i%2==0)?1c:-1c;1d=(i%2==0)?1d:-1d;f 1a=1c+(B*W);f 18=(1d+(v*13));f 1q=-(B*W);f 1l=-(v*13);f Y=1a-1H;f 14=18-1H;f l=c.2k(1r);l.A({r:18,t:1a,E:v,I:B});l.j(\'V\').A({r:1l,t:1q});c.1m(l);l.T();f D=50*i;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({O:\'1g\',E:\'1g\',I:\'1g\',t:1a+(v*1.5),r:18+(B*1.5)},G,J,P);W++;n(W==1h){W=0;13++}}},6Q:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'31\':c.g.Q;f G=3k/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/7));f v=(c.g.w);f B=C.K(c.g.M/s);1f(i=0;i<s;i++){f 14=(i%2==0?\'\':\'\')+v;f Y=(i*B);f l=c.1G();l.A({r:14+\'Z\',t:Y+\'Z\',E:v,I:B});l.j(\'V\').A({r:0,t:-Y});c.1m(l);f D=90*i;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({O:\'T\',t:Y,r:0},G,J,P)}},5a:q(F){f h=c;f F=$.1W({},{1k:R},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=2Y/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/10));f v=C.K(c.g.w/s);f B=(c.g.M);1f(i=0;i<s;i++){f 14=(v*(i));f Y=0;f l=c.1G();l.A({r:14,t:Y-50,E:v,I:B});l.j(\'V\').A({r:-(v*i),t:0});c.1m(l);n(F.1k){f 1k=c.5h(s);f D=50*1k;D=(i==(s-1))?(50*s):D}17{f D=70*(i);G=G-(i*2)}f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({O:\'T\',t:Y+\'Z\',r:14+\'Z\'},G,J,P)}},5b:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'79\':c.g.Q;f G=78/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/10));f v=C.K(c.g.w/s);f B=c.g.M;1f(i=0;i<s;i++){f Y=0;f 1a=B;f 5i=v*i;f l=c.1G();l.A({r:5i,t:1a,I:B,E:v});l.j(\'V\').A({r:-(5i)});c.1m(l);f 1k=c.5h(s);f D=30*1k;f P=(i==(s-1))?q(){h.1n()}:\'\';l.T().19(D).H({t:Y},G,J,P)}},6R:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=8P/c.g.1e;c.1p();f v=c.g.w;f B=c.g.M;f s=2;1f(i=0;i<s;i++){f 1a=0;f 18=0;f l=c.1G();l.A({r:18,t:1a,E:v,I:B});c.1m(l);f P=(i==(s-1))?q(){h.1n()}:\'\';l.H({O:\'T\',r:0,t:0},G,J,P)}},6S:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=1L/c.g.1e;c.1p();f v=c.g.w;f B=c.g.M;f s=4;1f(i=0;i<s;i++){n(i==0){f 1a=\'-2u\';f 18=\'-2u\'}17 n(i==1){f 1a=\'-2u\';f 18=\'2u\'}17 n(i==2){f 1a=\'2u\';f 18=\'-2u\'}17 n(i==3){f 1a=\'2u\';f 18=\'2u\'}f l=c.1G();l.A({r:18,t:1a,E:v,I:B});c.1m(l);f P=(i==(s-1))?q(){h.1n()}:\'\';l.H({O:\'T\',r:0,t:0},G,J,P)}},6T:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=2Y/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/16));f v=C.K(c.g.w/s);f B=c.g.M;1f(i=0;i<s;i++){f 14=(v*(i));f Y=0;f l=c.1G();l.A({r:14,t:Y-c.g.M,E:v,I:B});l.j(\'V\').A({r:-(v*i),t:0});c.1m(l);f D;n(i<=((s/2)-1)){D=7a-(i*1s)}17 n(i>((s/2)-1)){D=((i-(s/2))*1s)}D=D/2.5;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({t:Y+\'Z\',r:14+\'Z\',O:\'T\'},G,J,P)}},6U:q(F){f h=c;f F=$.1W({},{I:R},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=2Y/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/16));f v=C.K(c.g.w/s);f B=c.g.M;1f(i=0;i<s;i++){f 14=(v*(i));f Y=0;f l=c.1G();l.A({r:14,t:Y,E:v,I:B});l.j(\'V\').A({r:-(v*i),t:0});c.1m(l);f D;n(!F.I){n(i<=((s/2)-1)){D=7a-(i*1s)}17 n(i>((s/2)-1)){D=((i-(s/2))*1s)}f P=(i==(s-1))?q(){h.1n()}:\'\'}17{n(i<=((s/2)-1)){D=1s+(i*1s)}17 n(i>((s/2)-1)){D=(((s/2)-i)*1s)+(s*1v)}f P=(i==(s/2))?q(){h.1n()}:\'\'}D=D/2.5;n(!F.I){l.19(D).H({O:\'T\',t:Y+\'Z\',r:14+\'Z\',E:\'T\'},G,J,P)}17{G=G+(i*2);f J=\'1Q\';l.19(D).H({O:\'T\',t:Y+\'Z\',r:14+\'Z\',I:\'T\'},G,J,P)}}},5c:q(F){f h=c;f F=$.1W({},{I:S,G:1L,19:1v},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=F.G/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/16));f v=C.K(c.g.w/s);f B=c.g.M;1f(i=0;i<s;i++){f 14=(v*(i));f Y=0;f l=c.1G();l.A({r:14,t:Y,E:v,I:B});l.j(\'V\').A({r:-(v*i),t:0});c.1m(l);f D=F.19*i;f P=(i==(s-1))?q(){h.1n()}:\'\';n(!F.I){l.19(D).H({O:\'T\',t:Y+\'Z\',r:14+\'Z\',E:\'T\'},G,J,P)}17{f J=\'1Q\';l.19(D).H({O:\'T\',t:Y+\'Z\',r:14+\'Z\',I:\'T\'},G,J,P)}}},3I:q(F){f h=c;f F=$.1W({},{2j:\'t\',4r:\'4s\',s:7},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'7b\':c.g.Q;f G=8Q/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});c.k.j(\'.1i\').1g();f s=F.s;1f(i=0;i<s;i++){2L(F.2j){3H:N\'t\':f v=C.K(c.g.w/s);f B=c.g.M;f 1T=0;f 1C=(v*i);f 3l=-B;f 2M=1C;f 3m=B;f 3n=1C;f 3o=0;f 3p=1C;f 1q=0;f 1l=-1C;L;N\'2Z\':f v=C.K(c.g.w/s);f B=c.g.M;f 1T=0;f 1C=(v*i);f 3l=B;f 2M=1C;f 3m=-B;f 3n=1C;f 3o=0;f 3p=1C;f 1q=0;f 1l=-1C;L;N\'2r\':f v=c.g.w;f B=C.K(c.g.M/s);f 1T=(B*i);f 1C=0;f 3l=1T;f 2M=v;f 3m=1T;f 3n=-2M;f 3o=1T;f 3p=0;f 1q=-1T;f 1l=0;L;N\'r\':f v=c.g.w;f B=C.K(c.g.M/s);f 1T=(B*i);f 1C=0;f 3l=1T;f 2M=-v;f 3m=1T;f 3n=-2M;f 3o=1T;f 3p=0;f 1q=-1T;f 1l=0;L}2L(F.4r){N\'7c\':3H:f D=(i%2==0)?0:5g;L;N\'1k\':f D=30*(C.1k()*30);L;N\'4s\':f D=i*1v;L}f l=c.2k(1r);l.j(\'V\').A({r:1l,t:1q});l.A({t:1T,r:1C,E:v,I:B});c.1m(l);l.T();l.19(D).H({t:3l,r:2M},G,J);f 29=c.1G();29.j(\'V\').A({r:1l,t:1q});29.A({t:3m,r:3n,E:v,I:B});c.1m(29);29.T();f P=(i==(s-1))?q(){h.1n()}:\'\';29.19(D).H({t:3o,r:3p},G,J,P)}},6V:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=3k/c.g.1e;c.1p();f 1t=C.K(c.g.w/(c.g.w/8));f 1h=C.K(c.g.M/(c.g.w/8));f s=1t*1h;f v=C.K(c.g.w/1t);f B=C.K(c.g.M/1h);f 1c=0;f 1d=0;f W=0;f 13=0;f 4t=2w 4a;f 3q=2w 4a;1f(i=0;i<s;i++){1c=(i%2==0)?1c:-1c;1d=(i%2==0)?1d:-1d;f 1a=1c+(B*W);f 18=(1d+(v*13));4t[i]=[1a,18];W++;n(W==1h){W=0;13++}}W=0;13=0;1f(i=0;i<s;i++){3q[i]=i};f 3q=h.7d(3q);1f(i=0;i<s;i++){1c=(i%2==0)?1c:-1c;1d=(i%2==0)?1d:-1d;f 1a=1c+(B*W);f 18=(1d+(v*13));f 1q=-(B*W);f 1l=-(v*13);f Y=1a;f 14=18;1a=4t[3q[i]][0];18=4t[3q[i]][1];f l=c.1G();l.A({r:18+\'Z\',t:1a+\'Z\',E:v,I:B});l.j(\'V\').A({r:1l,t:1q});c.1m(l);f D=30*(C.1k()*30);n(i==(s-1))D=30*30;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({O:\'T\',t:Y+\'Z\',r:14+\'Z\'},G,J,P);W++;n(W==1h){W=0;13++}}},6X:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'31\':c.g.Q;f G=1L/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/10))*2;f v=C.K(c.g.w/s)*2;f B=(c.g.M)/2;f 13=0;1f(i=0;i<s;i++){4u=(i%2)==0?S:R;f 1I=(v*(13));f 1J=(4u)?-h.g.M:h.g.M;f 2a=(v*(13));f 1H=(4u)?0:(B);f 14=-(v*13);f Y=(4u)?0:-(B);f D=8R*13;f l=c.1G();l.A({r:1I,t:1J,E:v,I:B});l.j(\'V\').A({r:14+(v/1.5),t:Y}).19(D).H({r:14,t:Y},(G*1.9),\'1Q\');c.1m(l);f P=(i==(s-1))?q(){h.1n()}:\'\';l.T().19(D).H({t:1H,r:2a},G,J,P);n((i%2)!=0)13++}},6Y:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'31\':c.g.Q;f G=3k/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/10));f v=C.K(c.g.w/s);f B=(c.g.M);1f(i=0;i<s;i++){f 1I=(v*(i));f 1J=0;f 2a=(v*(i));f 1H=0;f 14=-(v*(i));f Y=0;f D=1v*i;f l=c.1G();l.A({r:1I,t:1J,E:v,I:B});l.j(\'V\').A({r:14+(v/1.5),t:Y}).19(D).H({r:14,t:Y},(G*1.1),\'4q\');c.1m(l);f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({t:1H,r:2a,O:\'T\'},G,J,P)}},6Z:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'4p\':c.g.Q;f G=1L/c.g.1e;c.1p();f s=C.K(c.g.w/(c.g.w/10));f 1z=1v;f 1D=C.5j(C.3r((c.g.w),2)+C.3r((c.g.M),2));f 1D=C.K(1D);1f(i=0;i<s;i++){f 1I=(h.g.w/2)-(1z/2);f 1J=(h.g.M/2)-(1z/2);f 2a=1I;f 1H=1J;f l=1A;l=c.4v({1N:h.g.1w,r:1I,t:1J,E:1z,I:1z,2p:{t:-1J,r:-1I}}).3J({\'4w-1D\':1D+\'Z\'});1z+=1v;c.1m(l);f D=70*i;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({t:1H,r:2a,O:\'T\'},G,J,P)}},71:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'4p\':c.g.Q;f G=1L/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f s=C.K(c.g.w/(c.g.w/10));f 1D=C.5j(C.3r((c.g.w),2)+C.3r((c.g.M),2));f 1D=C.K(1D);f 1z=1D;1f(i=0;i<s;i++){f 1I=(h.g.w/2)-(1z/2);f 1J=(h.g.M/2)-(1z/2);f 2a=1I;f 1H=1J;f l=1A;l=c.4v({1N:1r,r:1I,t:1J,E:1z,I:1z,2p:{t:-1J,r:-1I}}).3J({\'4w-1D\':1D+\'Z\'});1z-=1v;c.1m(l);l.T();f D=70*i;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({t:1H,r:2a,O:\'1g\'},G,J,P)}},72:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=1L/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f s=C.K(c.g.w/(c.g.w/10));f 1D=C.5j(C.3r((c.g.w),2)+C.3r((c.g.M),2));f 1D=C.K(1D);f 1z=1D;1f(i=0;i<s;i++){f 1I=(h.g.w/2)-(1z/2);f 1J=(h.g.M/2)-(1z/2);f 2a=1I;f 1H=1J;f l=1A;n($.8S.8T){l=c.2k(1r);l.A({r:1I,t:1J,E:1z,I:1z}).3J({\'4w-1D\':1D+\'Z\'});l.j(\'V\').A({r:-1I,t:-1J})}17{l=c.4v({1N:1r,r:1I,t:1J,E:1z,I:1z,2p:{t:-1J,r:-1I}}).3J({\'4w-1D\':1D+\'Z\'})}1z-=1v;c.1m(l);l.T();f D=1v*i;f P=(i==(s-1))?q(){h.1n()}:\'\';f 7e=(i%2==0)?\'7f\':\'-7f\';l.19(D).H({t:1H,r:2a,O:\'1g\',2b:7e},G,J,P)}},73:q(F){f h=c;c.g.1b=S;f J=(c.g.Q==\'\')?\'1Q\':c.g.Q;f G=2Y/c.g.1e;c.1p();f 1t=C.K(c.g.w/(c.g.w/8));f 1h=C.K(c.g.M/(c.g.M/4));f s=1t*1h;f v=C.K(c.g.w/1t);f B=C.K(c.g.M/1h);f 8U=R;f Y=0;f 14=0;f 3K=0;f 13=0;1f(i=0;i<s;i++){Y=B*3K;14=v*13;f D=30*(i);f l=c.1G();l.A({r:14,t:Y,E:v,I:B}).1g();l.j(\'V\').A({r:-14,t:-Y});c.1m(l);f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({E:\'T\',I:\'T\'},G,J,P);3K++;n(3K==1h){3K=0;13++}}},5d:q(F){f h=c;f F=$.1W({},{2j:\'t\'},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'4q\':c.g.Q;f G=2Y/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f s=12;f v=C.K(c.g.w/s);f B=c.g.M;f 1H=(F.2j==\'t\')?-B:B;1f(i=0;i<s;i++){f 1a=0;f 18=(v*i);f 1q=0;f 1l=-(v*i);f l=c.2k(1r);l.A({r:18+\'Z\',t:1a+\'Z\',E:v,I:B});l.j(\'V\').A({r:1l,t:1q});c.1m(l);l.T();f D=70*i;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({t:1H},G,J,P)}},74:q(F){f h=c;f F=$.1W({},{1k:R},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?\'5k\':c.g.Q;f G=3k/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});f 1t=C.K(c.g.w/(c.g.w/10));f s=1t;f v=C.K(c.g.w/1t);f B=c.g.M;1f(i=0;i<s;i++){f 1a=0;f 18=v*i;f 1q=0;f 1l=-(v*i);f 2a=\'+=\'+v;f l=c.2k(1r);l.A({r:0,t:0,E:v,I:B});l.j(\'V\').A({r:1l,t:1q});f 3L=c.2k(1r);3L.A({r:18+\'Z\',t:1a+\'Z\',E:v,I:B});3L.2V(l);c.1m(3L);l.T();3L.T();f D=50*i;f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({r:2a},G,J,P)}},5e:q(F){f h=c;f F=$.1W({},{2j:\'t\',4r:\'4s\',s:7,J:\'5k\'},F||{});c.g.1b=S;f J=(c.g.Q==\'\')?F.J:c.g.Q;f G=1L/c.g.1e;f 1r=c.k.j(\'.1i\').U(\'X\');c.1p();c.28();c.k.j(\'.1i\').U({\'X\':c.g.1w});c.k.j(\'.1i\').1g();f s=F.s;1f(i=0;i<s;i++){f v=C.K(c.g.w/s);f B=c.g.M;f 1T=0;f 1C=(v*i);f 3l=-B;f 2M=1C+v;f 3m=B;f 3n=1C;f 3o=0;f 3p=1C;f 1q=0;f 1l=-1C;2L(F.4r){N\'7c\':3H:f D=(i%2==0)?0:5g;L;N\'1k\':f D=30*(C.1k()*30);L;N\'4s\':f D=i*1v;L}f l=c.2k(1r);l.j(\'V\').A({r:1l,t:0});l.A({t:0,r:0,E:v,I:B});f 29=c.1G();29.j(\'V\').A({r:1l,t:0});29.A({t:0,r:-v,E:v,I:B});f 3M=c.1G();3M.2V(\'\').1F(l).1F(29);3M.A({t:0,r:1C,E:v,I:B});c.1m(3M);3M.T();l.T();29.T();f P=(i==(s-1))?q(){h.1n()}:\'\';l.19(D).H({r:v},G,J);29.19(D).H({r:0},G,J,P)}},1n:q(F){f h=c;c.k.j(\'.1i\').T();c.55();c.g.1b=R;c.k.j(\'.1i\').U({\'X\':c.g.1w});c.k.j(\'.1N a\').U({\'1O\':c.g.1R});n(!c.g.2P&&!c.g.2o&&!c.g.36){c.2S=3F(q(){h.3N()},c.g.2x)}h.3E()},3N:q(){c.2E(S);c.k.j(\'.l\').2C();n(!c.g.2o&&!c.g.36)c.4o()},1p:q(){n($.6b(c.g.4M))c.g.4M(c.g.1x,c);c.7g();c.7h();c.7i();c.7j()},7g:q(){f 7k=c.g.1j[c.g.1x][0];f 7l=c.g.1j[c.g.1x][1];f 7m=c.g.1j[c.g.1x][3];f 7n=c.g.1j[c.g.1x][4];c.g.1w=7k;c.g.1R=7l;c.g.33=7m;c.g.3V=7n},7h:q(){f h=c;c.k.j(\'.2U\').H(h.g.3x,1L).51(\'2U\');$(\'#4V\'+(c.g.1x+1)+\'4W\'+h.2G).H(h.g.3Z,3k).3B(\'2U\')},7j:q(){c.g.1x++;n(c.g.1x==c.g.1j.1y){c.g.1x=0}},1G:q(){n(c.g.1R!=\'#\'){f 1Z=$(\'<a 1O="\'+c.g.1R+\'"><V X="\'+c.g.1w+\'" /></a>\')}17{f 1Z=$(\'<V X="\'+c.g.1w+\'" />\')}1Z=c.4n(1Z);f l=$(\'<1o 1u="l"></1o>\');l.1F(1Z);11 l},2k:q(1r){n(c.g.1R!=\'#\'){f 1Z=$(\'<a 1O="\'+c.g.1R+\'"><V X="\'+1r+\'" /></a>\')}17{f 1Z=$(\'<V X="\'+1r+\'" />\')}1Z=c.4n(1Z);f l=$(\'<1o 1u="l"></1o>\');l.1F(1Z);11 l},4n:q(1Z){n(c.g.41){1Z.j(\'V\').I(c.g.M)}11 1Z},1m:q(l){c.k.j(\'.47\').1F(l)},5K:q(J){f 7o=[\'4p\',\'1Q\',\'4q\',\'8V\',\'8W\',\'8X\',\'8Y\',\'8Z\',\'91\',\'92\',\'93\',\'94\',\'95\',\'60\',\'96\',\'97\',\'31\',\'7b\',\'99\',\'5k\',\'9a\',\'9b\',\'79\',\'9c\',\'76\',\'5f\',\'9d\',\'9e\',\'9f\',\'9g\',];n(4x.9h(J,7o)>0){11 J}17{11\'\'}},5h:q(i){11 C.6c(C.1k()*i)},54:q(){c.k.j(\'.2J\').2V(c.g.33)},55:q(){f h=c;n(c.g.33!=1Y&&c.g.33!=\'\'&&h.g.2n){h.k.j(\'.2J\').9i(2Y)}},7i:q(){f h=c;c.k.j(\'.2J\').9j(1s,q(){h.54()})},6a:q(){f h=c;f 1U=h.g.1U;f 2y=h.g.2y;f 2H=h.g.2H;h.k.5U(q(){n(h.g.3b)h.g.2P=S;n(!h.g.3a){h.4y()}n(h.g.2g){n(h.g.3T){h.k.j(\'.1B\').T().A({O:0}).H({O:1U},2y)}n(h.g.3U){h.k.j(\'.24\').T().A({O:0}).H({O:1U},2y);h.k.j(\'.1V\').T().A({O:0}).H({O:1U},2y)}n(h.g.2A&&!h.g.2Q){h.k.j(\'.21\').1M().T().A({O:0}).H({O:1U},1s)}n(h.g.2R){h.k.j(\'.2l\').1M().T().A({O:0}).H({O:1U},1s)}}h.2E(S);n(h.g.2A&&!h.g.2Q&&!h.g.2g){h.k.j(\'.21\').1M().H({O:1},1s)}n(h.g.2R&&!h.g.2g){h.k.j(\'.2l\').1M().H({O:1},1s)}},q(){n(h.g.3b)h.g.2P=R;n(h.g.23==0&&!h.g.1b&&!h.g.2o){h.3E()}17 n(!h.g.2o){h.3O()}n(h.g.2g){n(h.g.3T){h.k.j(\'.1B\').3i("22",[]).T().A({O:1U}).H({O:0},2H)}n(h.g.3U){h.k.j(\'.24\').3i("22",[]).T().A({O:1U}).H({O:0},2H);h.k.j(\'.1V\').3i("22",[]).T().A({O:1U}).H({O:0},2H)}n(h.g.2A&&!h.g.2Q){h.k.j(\'.21\').1M().A({O:1U}).H({O:0},1s)}n(h.g.2R){h.k.j(\'.2l\').1M().A({O:1U}).H({O:0},1s)}}h.2E(S);n(!h.g.1b&&h.g.1j.1y>1){h.2S=3F(q(){h.3N()},h.g.2x-h.g.23);h.k.j(\'.1i\').U({\'X\':h.g.1w});h.k.j(\'.1N a\').U({\'1O\':h.g.1R})}n(h.g.2A&&!h.g.2Q&&!h.g.2g){h.k.j(\'.21\').1M().H({O:0.3},1s)}n(h.g.2R&&!h.g.2g){h.k.j(\'.2l\').1M().H({O:0.3},1s)}})},2E:q(9k){f h=c;9l(h.2S)},28:q(){n(c.g.1R!=\'#\'){c.k.j(\'.1N a\').U({\'1O\':c.g.1R,\'2i\':c.g.3V})}17{c.k.j(\'.1N a\').9m(\'1O\')}},2g:q(){c.k.j(\'.1B\').1g();c.k.j(\'.24\').1g();c.k.j(\'.1V\').1g();c.k.j(\'.2J\').1g();c.k.j(\'.21\').1g();c.k.j(\'.2l\').1g()},61:q(){f h=c;f 21=$(\'<a 1O="#" 1u="21">2A</a>\');h.k.1F(21);f 2F=(h.g.w-21.E())/2;f 3s=0;n(h.g.2R)2F-=25;n(h.g.4P==h.g.4O)3s=21.E()+5;f 2c={r:2F};2L(h.g.4O){N\'7p\':2c={r:5+3s,t:30};L;N\'7q\':2c={2r:5+3s,t:30};L;N\'7r\':2c={r:5+3s,2Z:5,t:\'2X\'};L;N\'7s\':2c={2r:5+3s,2Z:5,t:\'2X\'};L}21.A(2c).H({O:0.3},h.g.2y);$(5l).9n(q(e){f 7t=(e.3t?e.3t:e.9o);n(7t==27)$(\'#4z\').5m(\'2D\')});h.k.j(\'.21\').2D(q(){h.g.2Q=S;$(c).1M().H({O:0},h.g.2H);f 1o=$(\'<1o 4c="4z"></1o>\').I($(5l).I()).1g().2s(h.g.2y,0.98);f 5n=$(\'.k\').3g().t;f 2F=$(\'.k\').3g().r;f 7u=(($(2T).I()-$(\'.k\').I())/2)+$(5l).9p();f 7v=($(2T).E()-$(\'.k\').E())/2;h.k.7w(\'<1o 4c="4A"></1o>\');$(\'4T\').7x(1o);$(\'4T\').7x(h.k);h.k.A({\'t\':5n,\'r\':2F,\'2p\':\'4R\',\'z-5H\':9q}).H({\'t\':7u,\'r\':7v},9r,\'31\');$(\'#4A\').E($(\'.k\').E()).I($(\'.k\').I()).A({\'4l\':\'4B\'}).2s(2z,0.3);$(\'#4z\').2D(q(){n($(c).9s(\'7y\'))11 R;h.g.2Q=R;$(c).3B(\'7y\');$(\'#4A\').7w($(\'.k\'));n(!h.g.2g)h.k.j(\'.21\').H({O:0.3},1s);h.k.1M().H({\'t\':5n,\'r\':2F},2z,\'31\',q(){$(c).A({\'2p\':\'9t\',\'t\':0,\'r\':0});$(\'#4A\').2C()});$(\'#4z\').2s(h.g.2H,0,q(){$(c).2C()});11 R});11 R})},62:q(){f h=c;f 2l=$(\'<a 1O="#" 1u="2l">7z</a>\');h.k.1F(2l);f 2F=(h.g.w-2l.E())/2;n(h.g.2A)2F+=25;f 2c={r:2F};2L(h.g.4P){N\'7p\':2c={r:5,t:30};L;N\'7q\':2c={2r:5,t:30};L;N\'7r\':2c={r:5,2Z:5,t:\'2X\'};L;N\'7s\':2c={2r:5,2Z:5,t:\'2X\'};L}2l.A(2c).H({O:0.3},h.g.2y);2l.2D(q(){n(!h.g.2o){$(c).2V(\'9u\');$(c).2s(1v,0.5).2s(1v,1);$(c).3B(\'7A\');h.4y();h.g.2o=S;h.2E(S)}17{n(!h.g.1b&&!h.k.j(\'.1E\').5J(\':9v\')){h.g.23=0}17{h.3O()}n(!h.g.1E)h.3O();h.g.2o=R;$(c).2V(\'7z\');$(c).2s(1v,0.5).2s(1v,1);$(c).51(\'7A\');n(!h.g.3b){h.2E(S);n(!h.g.1b&&h.g.1j.1y>1){h.2S=3F(q(){h.3N()},h.g.2x-h.g.23);h.k.j(\'.1i\').U({\'X\':h.g.1w});h.k.j(\'.1N a\').U({\'1O\':h.g.1R})}}}11 R})},5o:q(3A){f 48=0,5p;1f(5p 7B 3A){n(3A.9w(5p))48++}11 48},63:q(){f h=c;f 1E=$(\'<1o 1u="1E"></1o>\');h.k.1F(1E);n(h.5o(h.g.2h)==0){n(3h(1E.A(\'E\'))>0){h.g.2h.E=3h(1E.A(\'E\'))}17{h.g.2h={E:h.g.w,I:5}}}n(h.5o(h.g.2h)>0&&h.g.2h.E==1Y){h.g.2h.E=h.g.w}1E.A(h.g.2h).1g()},7C:q(){f h=c;n(h.g.2P||h.g.2o||h.g.36||!h.g.1E)11 R;h.k.j(\'.1E\').1g().7D().E(h.g.2h.E).H({E:\'T\'},h.g.2x,\'7E\')},57:q(){f h=c;n(!h.g.1b){h.k.j(\'.1E\').1M()}},7F:q(){f h=c;n(h.g.2P||h.g.2o||!h.g.1E)11 R;h.k.j(\'.1E\').7D().H({E:h.g.2h.E},(h.g.2x-h.g.23),\'7E\')},6K:q(){f h=c;n(!h.g.1E)11 R;h.k.j(\'.1E\').1M().9x(2z,q(){$(c).E(h.g.2h.E)})},3E:q(){f h=c;h.g.3a=R;f 3u=2w 5q();h.g.23=0;h.g.44=3u.5r();h.7C()},4y:q(){f h=c;n(h.g.3a)11 R;h.g.3a=S;f 3u=2w 5q();h.g.23+=3u.5r()-h.g.44;h.57()},3O:q(){f h=c;h.g.3a=R;f 3u=2w 5q();h.g.44=3u.5r();h.7F()},64:q(){f h=c;$(2T).9y(q(e){n(e.3t==39||e.3t==40){h.k.j(\'.1V\').5m(\'2D\')}17 n(e.3t==37||e.3t==38){h.k.j(\'.24\').5m(\'2D\')}})},4v:q(F){f l=$(\'<1o 1u="l"></1o>\');l.A({\'r\':F.r,\'t\':F.t,\'E\':F.E,\'I\':F.I,\'4l-1N\':\'5M(\'+F.1N+\')\',\'4l-2p\':F.2p.r+\'Z \'+F.2p.t+\'Z\'});11 l},7d:q(3P){f h=c;f 4C=2w 4a();f 4D;5s(3P.1y>0){4D=h.7G(0,3P.1y-1);4C[4C.1y]=3P[4D];3P.9z(4D,1)}11 4C},7G:q(5t,7H){f 4E;9A 4E=C.1k();5s(4E==1);11(4E*(7H-5t+1)+5t)|0},69:q(){f h=c;$(2T).4g(\'9B\',q(){h.g.36=S;h.4y();h.2E(S)});$(2T).4g(\'2A\',q(){n(h.g.1j.1y>1){h.g.36=R;n(h.g.23==0){h.3E()}17{h.3O()}n(h.g.23<=h.g.2x){h.2S=3F(q(){h.3N()},h.g.2x-h.g.23);h.k.j(\'.1i\').U({\'X\':h.g.1w});h.k.j(\'.1N a\').U({\'1O\':h.g.1R})}}})}});$.2f.3J=q(3v){f A={};f 5u=[\'9C\',\'9D\',\'o\',\'9E\'];1f(f 2m 7B 3v){1f(f i=0;i<5u.1y;i++)A[\'-\'+5u[i]+\'-\'+2m]=3v[2m];A[2m]=3v[2m]}c.A(A);11 c};f 3Q=\'9F\';$.2f.2b=q(2N){f 26=$(c).A(\'1K\')||\'4B\';n(2d 2N==\'1Y\'){n(26){f m=26.4F(/2b\\(([^)]+)\\)/);n(m&&m[1]){11 m[1]}}11 0}f m=2N.7I().4F(/^(-?\\d+(\\.\\d+)?)(.+)?$/);n(m){n(m[3])3Q=m[3];$(c).A(\'1K\',26.7J(/4B|2b\\([^)]*\\)/,\'\')+\'2b(\'+m[1]+3Q+\')\')}11 c};$.2f.2O=q(2N,4j,F){f 26=$(c).A(\'1K\');n(2d 2N==\'1Y\'){n(26){f m=26.4F(/2O\\(([^)]+)\\)/);n(m&&m[1]){11 m[1]}}11 1}$(c).A(\'1K\',26.7J(/4B|2O\\([^)]*\\)/,\'\')+\'2O(\'+2N+\')\');11 c};f 7K=$.22.4Q.7L;$.22.4Q.7L=q(){n(c.2m==\'2b\'){11 3c($(c.4G).2b())}17 n(c.2m==\'2O\'){11 3c($(c.4G).2O())}11 7K.5v(c,5w)};$.22.7M.2b=q(22){$(22.4G).2b(22.7N+3Q)};$.22.7M.2O=q(22){$(22.4G).2O(22.7N)};f 7O=$.2f.H;$.2f.H=q(2m){n(2d 2m[\'2b\']!=\'1Y\'){f m=2m[\'2b\'].7I().4F(/^(([+-]=)?(-?\\d+(\\.\\d+)?))(.+)?$/);n(m&&m[5]){3Q=m[5]}2m[\'2b\']=m[1]}11 7O.5v(c,5w)};q 7P(7Q){f 7R=[\'1K\',\'9G\',\'9H\',\'9I\',\'9J\'];f p;5s(p=7R.9K()){n(2d 7Q.26[p]!=\'1Y\'){11 p}}11\'1K\'};f 2v=1A;f 7S=$.2f.A;$.2f.A=q(2e,2N){n(2v===1A){n(2d $.7T!=\'1Y\'){2v=$.7T}17 n(2d $.3v!=\'1Y\'){2v=$.3v}17{2v={}}}n(2d 2v[\'1K\']==\'1Y\'&&(2e==\'1K\'||(2d 2e==\'7U\'&&2d 2e[\'1K\']!=\'1Y\'))){2v[\'1K\']=7P(c.7V(0))}n(2v[\'1K\']!=\'1K\'){n(2e==\'1K\'){2e=2v[\'1K\'];n(2d 2N==\'1Y\'&&4x.26){11 4x.26(c.7V(0),2e)}}17 n(2d 2e==\'7U\'&&2d 2e[\'1K\']!=\'1Y\'){2e[2v[\'1K\']]=2e[\'1K\'];9L 2e[\'1K\']}}11 7S.5v(c,5w)}})(4x);',62,606,'||||||||||||this|||var|settings|self||find|box_skitter|box_clone||if|||function|left|total|top||width_box|width_skitter||||css|height_box|Math|delay_time|width|options|time_animate|animate|height|easing|ceil|break|height_skitter|case|opacity|callback|easing_default|false|true|show|attr|img|col_t|src|_btop|px||return||col|_bleft|||else|_vleft|delay|_vtop|is_animating|init_top|init_left|velocity|for|hide|division_h|image_main|images_links|random|_vleft_image|addBoxClone|finishAnimation|div|setActualLevel|_vtop_image|image_old|200|division_w|class|100|image_atual|image_i|length|size_box|null|info_slide|_ileftc|radius|progressbar|append|getBoxClone|_ftop|_ileft|_itop|transform|500|stop|image|href|class_info|easeOutQuad|link_atual|image_number|_itopc|opacity_elements|next_button|extend|animation_type|undefined|img_clone||focus_button|fx|elapsedTime|prev_button||style||setLinkAtual|box_clone_next|_fleft|rotate|cssPosition|typeof|arg|fn|hideTools|progressbar_css|target|direction|getBoxCloneImgOld|play_pause_button|prop|label|is_paused|position|ul|right|fadeTo|loading|100px|_propsObj|new|interval|interval_in_elements|300|focus|info_slide_thumb|remove|click|clearTimer|_left|number_skitter|interval_out_elements|span|label_skitter|link|switch|_fleftc|val|scale|is_hover_box_skitter|foucs_active|controls|timer|window|image_number_select|html|new_x|auto|400|bottom||easeOutExpo|sk|label_atual|xml|preview|is_blur||||is_paused_time|stop_over|parseFloat|rel|text|li|offset|parseInt|queue|_i_animation|700|_ftopc|_itopn|_ileftn|_ftopn|_fleftn|spread|pow|_space|keyCode|date|props|each|animateNumberOut|dots|width_label|obj|addClass|w_info_slide_thumb|fadeIn|startTime|setTimeout|animations_functions|default|animationDirection|css3|line|box_clone_main|box_clone_container|completeMove|resumeTime|arrayOrigem|rotateUnits|skitter|animation|numbers|navigation|target_atual|random_ia|thumbs|color|animateNumberActive||fullscreen|center||timeStart|with_animations|auto_play|container_skitter|size|initial_select_class|Array|dimension_thumb|id|width_info_slide|width_value|jumpToImage|bind|imageNumber|preview_slide|duration|image_loading|background|img_link|resizeImage|nextImage|easeInQuad|easeInOutQuad|delay_type|sequence|order|mod|getBoxCloneBackground|border|jQuery|pauseTime|overlay_skitter|mark_position|none|arrayDestino|indice|numRandom|match|elem|_self|backgroundColor|fff|animateNumberOver|onLoad|imageSwitched|numbers_align|focus_position|controls_position|prototype|absolute|1000|body|addImageLink|image_n_|_|width_image|x_value|info_slide_dots||removeClass|mouseover|init_pause|setValueBoxText|showBoxText|mouseOverInit|pauseProgressBar|animationCube|animationCubeStop|animationShowBars|animationTube|animationBlindDimension|animationDirectionBars|animationSwapBars|easeOutBack|150|getRandom|vleft|sqrt|easeOutCirc|document|trigger|_top|objectSize|key|Date|getTime|while|valorIni|prefixes|apply|arguments|skitters|push|defaults|show_randomly|enable_navigation_keys|mouseOverButton|mouseOutButton|structure|number|setup|index|or|is|getEasing|type|url|container_thumbs|copy_info_slide|y_value|novo_width|15px|sort|mouseleave|hover|width_preview_ul|_left_info|_left_image|_left_preview|_left_ul|easeOutSine|focusSkitter|setControls|addProgressBar|enableNavigationKeys|loadImages|self_il|start|images|windowFocusOut|stopOnMouseOver|isFunction|floor|cube|cubeRandom|block|cubeStop|cubeStopRandom|cubeHide|cubeSize|horizontal|showBars|showBarsRandom|tube|fade|fadeFour|paralell|blind|blindHeight|blindWidth|directionTop|directionBottom|directionRight|directionLeft|cubeSpread|glassCube|glassBlock|circles|circlesInside|circlesRotate|cubeShow|upBars|downBars|hideBars|swapBars|swapBarsBack|hideProgressBar|random_id|total_with_animations|animationBlock|animationCubeHide|animationCubeSize|animationHorizontal|animationFade|animationFadeFour|animationParalell|animationBlind|animationCubeSpread|animationCubeJelly|animationGlassCube|animationGlassBlock|animationCircles||animationCirclesInside|animationCirclesRotate|animationCubeShow|animationHideBars||easeInBack|20px|600|easeOutElastic|1400|easeInOutExpo|zebra|shuffleArray|_rotate|20deg|setImageLink|addClassNumber|hideBoxText|increasingImage|name_image|link_image|label_image|target_link|easing_accepts|leftTop|rightTop|leftBottom|rightBottom|code|_topFinal|_leftFinal|before|prepend|finish_overlay_skitter|pause|play_button|in|startProgressBar|dequeue|linear|resumeProgressBar|randomUnique|valorFim|toString|replace|curProxied|cur|step|now|animateProxied|getTransformProperty|element|properties|proxied|cssProps|object|get|data|skitter_number|2500|time_interval||333|000|cc3333|max_number_height|prev|next|overflown|hidden|console|warn|Width|Skitter|Slideshow|ajax|GET|async|dataType|success|slide|json|label_text|clone|outerWidth|mousemove|pageX|pageY|scroll_thumbs|box_scroll_thumbs|5px|0px|eq|mouseenter|image_current_preview|preview_slide_current|Loading|9999em|Image|load|error|white|black|Error|One|more|were|not|found|1500|randomSmart|cubeJelly|800|1200|120|browser|mozilla|last|easeInCubic|easeOutCubic|easeInOutCubic|easeInQuart|easeOutQuart||easeInOutQuart|easeInQuint|easeOutQuint|easeInOutQuint|easeInSine|easeInOutSine|easeInExpo||easeInCirc|easeInOutCirc|easeInElastic|easeInOutElastic|easeInOutBack|easeInBounce|easeOutBounce|easeInOutBounce|inArray|slideDown|slideUp|force|clearInterval|removeAttr|keypress|which|scrollTop|9999|2000|hasClass|relative|play|visible|hasOwnProperty|fadeOut|keydown|splice|do|blur|moz|ms|webkit|deg|WebkitTransform|msTransform|MozTransform|OTransform|shift|delete'.split('|'),0,{}))

/***/ },
/* 5 */
/***/ function(module, exports) {

	jQuery.fn.extend({
		everyTime: function(interval, label, fn, times, belay) {
			return this.each(function() {
				jQuery.timer.add(this, interval, label, fn, times, belay);
			});
		},
		oneTime: function(interval, label, fn) {
			return this.each(function() {
				jQuery.timer.add(this, interval, label, fn, 1);
			});
		},
		stopTime: function(label, fn) {
			return this.each(function() {
				jQuery.timer.remove(this, label, fn);
			});
		}
	});
	
	jQuery.extend({
		timer: {
			guid: 1,
			global: {},
			regex: /^([0-9]+)\s*(.*s)?$/,
			powers: {
				// Yeah this is major overkill...
				'ms': 1,
				'cs': 10,
				'ds': 100,
				's': 1000,
				'das': 10000,
				'hs': 100000,
				'ks': 1000000
			},
			timeParse: function(value) {
				if (value == undefined || value == null)
					return null;
				var result = this.regex.exec(jQuery.trim(value.toString()));
				if (result[2]) {
					var num = parseInt(result[1], 10);
					var mult = this.powers[result[2]] || 1;
					return num * mult;
				} else {
					return value;
				}
			},
			add: function(element, interval, label, fn, times, belay) {
				var counter = 0;
	
				if (jQuery.isFunction(label)) {
					if (!times)
						times = fn;
					fn = label;
					label = interval;
				}
	
				interval = jQuery.timer.timeParse(interval);
	
				if (typeof interval != 'number' || isNaN(interval) || interval <= 0)
					return;
	
				if (times && times.constructor != Number) {
					belay = !!times;
					times = 0;
				}
	
				times = times || 0;
				belay = belay || false;
	
				if (!element.$timers)
					element.$timers = {};
	
				if (!element.$timers[label])
					element.$timers[label] = {};
	
				fn.$timerID = fn.$timerID || this.guid++;
	
				var handler = function() {
					if (belay && this.inProgress)
						return;
					this.inProgress = true;
					if ((++counter > times && times !== 0) || fn.call(element, counter) === false)
						jQuery.timer.remove(element, label, fn);
					this.inProgress = false;
				};
	
				handler.$timerID = fn.$timerID;
	
				if (!element.$timers[label][fn.$timerID])
					element.$timers[label][fn.$timerID] = window.setInterval(handler,interval);
	
				if ( !this.global[label] )
					this.global[label] = [];
				this.global[label].push( element );
	
			},
			remove: function(element, label, fn) {
				var timers = element.$timers, ret;
	
				if ( timers ) {
	
					if (!label) {
						for ( label in timers )
							this.remove(element, label, fn);
					} else if ( timers[label] ) {
						if ( fn ) {
							if ( fn.$timerID ) {
								window.clearInterval(timers[label][fn.$timerID]);
								delete timers[label][fn.$timerID];
							}
						} else {
							for ( var fn in timers[label] ) {
								window.clearInterval(timers[label][fn]);
								delete timers[label][fn];
							}
						}
	
						for ( ret in timers[label] ) break;
						if ( !ret ) {
							ret = null;
							delete timers[label];
						}
					}
	
					for ( ret in timers ) break;
					if ( !ret )
						element.$timers = null;
				}
			}
		}
	});
	
	//IE
	if(!$.support.noCloneChecked){
		$(window).one("unload", function() {
			var global = jQuery.timer.global;
			for ( var label in global ) {
				var els = global[label], i = els.length;
				while ( --i )
					jQuery.timer.remove(els[i], label);
			}
		});
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** set_flickslide.js
 **/